import constants from "./constants.js";
import humps from "humps";
import ipaddr from "ipaddr.js";
import {
  FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY,
  FEATURE_C2C_AUDIT_LOG,
  FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE,
  FEATURE_JKC_STUN,
  FEATURE_BD_1939_IP_RESTRICTION,
} from "@/components/feature_toggles/feature_toggle";
import { FEATURE_BD_2018_RESERVE_TALK_CLIENT_SETTINGS } from "@/components/feature_toggles/feature_toggle";

export default {
  notifyMessage(self, msgTitle, msgText, duration, customClass) {
    let options = { title: msgTitle, message: msgText, offset: 100 };
    if (duration) {
      options.duration = duration;
    }
    if (customClass) {
      options.customClass = customClass;
    }
    switch (msgTitle) {
      case "Info":
        self.$notify.info(options);
        break;
      case "Success":
        options.duration = 1000;
        self.$notify.success(options);
        break;
      case "Warning":
        self.$notify.warning(options);
        break;
      case "Error":
        options.duration = 0;
        self.$notify.error(options);
        break;
    }
  },
  notifyMessageWithDuration(self, msgTitle, msgText, duration) {
    switch (msgTitle) {
      case "Info":
        self.$notify.info({ title: msgTitle, message: msgText, offset: 100, duration: duration });
        break;
      case "Success":
        self.$notify.success({
          title: msgTitle,
          message: msgText,
          offset: 100,
          duration: duration,
        });
        break;
      case "Warning":
        self.$notify.warning({
          title: msgTitle,
          message: msgText,
          offset: 100,
          duration: duration,
        });
        break;
      case "Error":
        self.$notify.error({ title: msgTitle, message: msgText, offset: 100, duration: duration });
        break;
    }
  },
  getMessageText(i18n, messageId) {
    switch (i18n.locale) {
      case "en":
        return i18n.messages.en.message[messageId];
      case "ja":
        return i18n.messages.ja.message[messageId];
    }
  },
  getCsvErrorDescription(i18n, errorCode) {
    switch (errorCode) {
      case constants.STATUS_ERROR_INVALID_PARAMETER:
        return this.getMessageText(i18n, "error_csv_parameter");
      case constants.STATUS_ERROR_DENIED:
        return this.getMessageText(i18n, "error_csv_access_denied");
      case constants.STATUS_ERROR_ALREADY_EXISTED:
        return this.getMessageText(i18n, "error_csv_duplicateId");
      case constants.STATUS_ERROR_TOO_MANY_ENTRY:
        return this.getMessageText(i18n, "error_csv_exceeds_data");
      case constants.STATUS_ERROR_NOT_FOUND:
        return this.getMessageText(i18n, "error_csv_not_found");
      case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
        return this.getMessageText(i18n, "error_csv_object_not_found");
      case constants.STATUS_ERROR_PARENT_NOT_FOUND:
        return this.getMessageText(i18n, "error_csv_invalid_layerId");
      case constants.STATUS_ERROR_INVALID_PASSWORD_FORMAT:
        return this.getMessageText(i18n, "error_csv_invalid_password");
      case constants.STATUS_ERROR_INVALID_USER_OPTION:
        return this.getMessageText(i18n, "error_csv_invalid_option");
      case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
        return this.getMessageText(i18n, "error_csv_insufficient_license");
      case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT:
        return this.getMessageText(i18n, "error_csv_insufficient_option");
      case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT_LINKED_TENANT:
        return this.getMessageText(i18n, "error_csv_insufficient_option_linked_tenant");
      case constants.STATUS_ERROR_INVALID_DISPLAYNAME:
        return this.getMessageText(i18n, "error_csv_invalid_displayName");
      case constants.STATUS_ERROR_USER_NOT_FOUND:
        return this.getMessageText(i18n, "error_csv_invalid_userId");
      case constants.STATUS_ERROR_TALKGROUP_NOT_FOUND:
        return this.getMessageText(i18n, "error_csv_invalid_groupId");
      case constants.STATUS_ERROR_OPTION_UNMATCH:
        return this.getMessageText(i18n, "error_csv_option_unmatch");
      case constants.STATUS_ERROR_USER_EXISTS:
        return this.getMessageText(i18n, "error_csv_option_cannot_changed");
      case constants.STATUS_ERROR_INVALID_ORGANIZATION:
        return this.getMessageText(i18n, "error_csv_invalid_organization");
      case constants.STATUS_ERROR_INVALID_TITLE:
        return this.getMessageText(i18n, "error_csv_invalid_title");
      case constants.STATUS_ERROR_INVALID_PHONE_NUMBER:
        return this.getMessageText(i18n, "error_csv_invalid_phoneNumber");
      case constants.STATUS_ERROR_INVALID_EMAIL:
        return this.getMessageText(i18n, "error_csv_invalid_email");
      case constants.STATUS_ERROR_INVALID_SAVE_TALKRECORD:
        return this.getMessageText(i18n, "error_csv_invalid_save_talkRecord");
      case constants.STATUS_ERROR_INVALID_SAVE_LIVECAST:
        return this.getMessageText(i18n, "error_csv_invalid_save_livecast");
      case constants.STATUS_ERROR_INVALID_DURATION_LIMIT:
        return this.getMessageText(i18n, "error_csv_invalid_talkTimer");
      case constants.STATUS_ERROR_INVALID_VIDEO_DURATION_LIMIT:
        return this.getMessageText(i18n, "error_csv_invalid_videoTimer");
      case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
        return this.getMessageText(i18n, "error_csv_exceeds_limit");
      case constants.STATUS_ERROR_EXCEEDS_MANDATORY_LIMIT:
        return this.getMessageText(i18n, "error_csv_exceeds_mandatory");
      case constants.STATUS_ERROR_INVALID_CSV_TEMPLATE:
        return this.getMessageText(i18n, "error_csv_invalid_template");
      case constants.STATUS_ERROR_USER_HAS_EXPORTED:
        return this.getMessageText(i18n, "error_csv_user_has_exported");
      case constants.STATUS_ERROR_INVALID_UTF8:
        return this.getMessageText(i18n, "error_csv_invalid_utf8");
      case constants.STATUS_ERROR_INVALID_CSV_FORMAT:
        return this.getMessageText(i18n, "error_csv_invalid_csv_format");
      case constants.STATUS_ERROR_INVALID_SUBGROUP_ID:
        return this.getMessageText(i18n, "error_csv_invalid_subGroupId");
      case constants.STATUS_ERROR_UNDELETABLE_OBJECT:
        return this.getMessageText(i18n, "error_csv_undeletable_object");
      case constants.STATUS_ERROR_MULTI_AND_INTERRUPT_SIMULTANEOUSLY:
        return this.getMessageText(i18n, "error_multi_and_interrupt_simultaneously");
      case constants.STATUS_ERROR_STILL_ASSIGNED:
        return this.getMessageText(i18n, "error_csv_join_group");
      case constants.STATUS_ERROR_BELL_ASSIGNED:
        return this.getMessageText(i18n, "error_csv_bell_target_assigned_group");
      case constants.STATUS_ERROR_NO_MORE_FREE_SLOT:
        return this.getMessageText(i18n, "error_csv_exceeds_free_slot");
      case constants.STATUS_ERROR_BELL_AUTH_USER_LIMIT:
        return this.getMessageText(i18n, "error_csv_bell_auth_user_limit");
      case constants.STATUS_ERROR_BELL_CSV_INVALID_TIMEZONE_HEADER:
        return this.getMessageText(i18n, "error_csv_invalid_bell_timezone_header");
      default:
        return this.getMessageText(i18n, "error_csv_unknown").replace("{errorCode}", errorCode);
    }
  },
  getMessageArgsText(i18n, messageId, args = {}) {
    let message = "";
    switch (i18n.locale) {
      case "en":
        message = i18n.messages.en.message[messageId];
        break;
      case "ja":
        message = i18n.messages.ja.message[messageId];
        break;
      default:
        message = i18n.messages.en.message[messageId];
    }
    Object.keys(args).forEach((key) => {
      const placeholder = new RegExp(`{${key}}`, "g");
      message = message.replace(placeholder, args[key]);
    });
    return message;
  },
  classifyTalkgroupProcessorDefinitions(processorDefinitionIds = [], processorDefinitionList = []) {
    let targetStorage = null;
    const processorDefinitionIdsWithoutStorage = [];

    if (!Array.isArray(processorDefinitionIds) || !Array.isArray(processorDefinitionList)) {
      return { targetStorage, processorDefinitionIdsWithoutStorage };
    }

    for (let processorDefinitionId of processorDefinitionIds) {
      let foundDefinition = null;
      for (let processorDefinition of processorDefinitionList) {
        if (processorDefinition.id == processorDefinitionId) {
          foundDefinition = processorDefinition;
          break;
        }
      }
      if (foundDefinition != null) {
        if (foundDefinition.serviceId == constants.VAULT_SERVICE_STORAGE) {
          targetStorage = foundDefinition;
        } else {
          processorDefinitionIdsWithoutStorage.push(foundDefinition.id);
        }
      }
    }

    return { targetStorage, processorDefinitionIdsWithoutStorage };
  },
  getTalkgroupStorageDisplayName(i18n, processorDefinitionIds = [], processorDefinitionList = []) {
    const { targetStorage } = this.classifyTalkgroupProcessorDefinitions(
      processorDefinitionIds,
      processorDefinitionList
    );
    return targetStorage == null
      ? this.getMessageText(i18n, "item_default")
      : targetStorage.displayName;
  },

  getTenantName(appData, tenantId) {
    for (let tenant of appData.tenantList) {
      if (tenant.tenantId == tenantId) {
        return tenant.name;
      }
    }
    for (let tenant of appData.importedTenantList) {
      if (tenant.tenantId == tenantId) {
        return tenant.tenantName;
      }
    }
    for (let tenant of appData.exportedTenantList) {
      if (tenant.tenantId == tenantId) {
        return tenant.tenantName;
      }
    }
  },

  // get display name of license.
  getLicenseName(i18n, licenseType) {
    switch (licenseType) {
      case constants.LICENSE_USER:
        return this.getMessageText(i18n, "item_licenseName_voice");
      case constants.LICENSE_SPEECH_TEXT:
      case constants.RECURRING_SPEECH_TEXT:
      case constants.CHARGE_SPEECH_TEXT:
        return this.getMessageText(i18n, "item_licenseName_speechToText");
      case constants.LICENSE_TRANSLATION:
      case constants.RECURRING_TRANSLATION:
      case constants.CHARGE_TRANSLATION:
        return this.getMessageText(i18n, "item_licenseName_translation");
      case constants.LICENSE_CONFIG:
        return this.getMessageText(i18n, "item_licenseName_setting");
      case constants.LICENSE_ACCESS_LOG:
        return this.getMessageText(i18n, "item_licenseName_audit");
      case constants.LICENSE_TRACKING:
        return this.getMessageText(i18n, "item_licenseName_locationTrack");
      case constants.LICENSE_MAP_TALK:
        return this.getMessageText(i18n, "item_licenseName_mapTalk");
      case constants.LICENSE_HISTORY_RETENTION:
        return this.getMessageText(i18n, "item_licenseName_history");
        break;
      case constants.LICENSE_HISTORY_RETENTION_ADVANCED:
        return this.getMessageText(i18n, "item_licenseName_history_advanced");
        break;
      case constants.LICENSE_HISTORY_RETENTION_TRACKING:
        return this.getMessageText(i18n, "item_licenseName_history_tracking");
        break;
      case constants.LICENSE_VIDEO:
        return this.getMessageText(i18n, "item_licenseName_video");
        break;
      case constants.RECURRING_DATA_TRANSFER:
      case constants.CHARGE_DATA_TRANSFER:
        return this.getMessageText(i18n, "item_licenseName_dataTransfer");
        break;
      case constants.LICENSE_SAML:
        return this.getMessageText(i18n, "item_licenseName_saml");
        break;
      case constants.OFF_PLAN_LICENSE_BELL:
        return this.getMessageText(i18n, "item_licenseName_bell");
        break;
      case constants.OFF_PLAN_LICENSE_DEDICATED:
        return this.getMessageText(i18n, "item_licenseName_dedicated");
        break;
      case constants.OFF_PLAN_LICENSE_CALL_CENTER:
        return this.getMessageText(i18n, "item_licenseName_call_center");
        break;
      case constants.OFF_PLAN_LICENSE_BUDDY_BOT_API:
        return "BuddyBot API";
        break;
      case constants.OFF_PLAN_LICENSE_MAP_IMAGE_OVERLAY:
        return this.getMessageText(i18n, "item_licenseName_map_image_overlay");
        break;
      case constants.OFF_PLAN_LICENSE_CALL:
        return this.getMessageText(i18n, "item_licenseName_call");
        break;
      case constants.OFF_PLAN_LICENSE_SAFETY_SUPPORT:
        return this.getMessageText(i18n, "item_licenseName_safety_support");
        break;
      case constants.LICENSE_PLAN_LITE:
        return this.getMessageText(i18n, "item_planType_light");
        break;
      case constants.LICENSE_PLAN_STANDARD:
        return this.getMessageText(i18n, "item_planType_standard");
        break;
      case constants.LICENSE_PLAN_ENTERPRISE:
        return this.getMessageText(i18n, "item_planType_enterprise");
        break;
      case constants.LICENSE_PLAN_TALK_LITE:
        return "Talk Lite";
        break;
      case constants.LICENSE_PLAN_TALK_ENT:
        return "Talk Enterprise";
        break;
      case constants.LICENSE_PLAN_LIVE_LITE:
        return "Livecast Lite";
        break;
      case constants.LICENSE_PLAN_LIVE_ENT:
        return "Livecast Enterprise";
        break;
      case constants.PLAN_UPGRADE_TL_TE:
        return "Upgrade (Talk Lite to Talk Enterprise)";
        break;
      case constants.PLAN_UPGRADE_TL_LL:
        return "Upgrade (Talk Lite to Livecast Lite)";
        break;
      case constants.PLAN_UPGRADE_TL_LE:
        return "Upgrade (Talk Lite to Livecast Enterprise)";
        break;
      case constants.PLAN_UPGRADE_TE_LE:
        return "Upgrade (Talk Enterprise to Livecast Enterprise)";
        break;
      case constants.PLAN_UPGRADE_LL_LE:
        return "Upgrade (Livecast Lite to Livecast Enterprise)";
        break;
      default:
        return null;
    }
  },

  getLicenseNameWithCategory(i18n, licenseType) {
    let licenseName = this.getLicenseName(i18n, licenseType);
    switch (licenseType) {
      case constants.OFF_PLAN_LICENSE_BELL:
      case constants.OFF_PLAN_LICENSE_DEDICATED:
      case constants.OFF_PLAN_LICENSE_CALL_CENTER:
      case constants.OFF_PLAN_LICENSE_BUDDY_BOT_API:
      case constants.OFF_PLAN_LICENSE_MAP_IMAGE_OVERLAY:
      case constants.OFF_PLAN_LICENSE_CALL:
      case constants.OFF_PLAN_LICENSE_SAFETY_SUPPORT:
        return licenseName + " (プラン外)";
      case constants.RECURRING_SPEECH_TEXT:
      case constants.RECURRING_TRANSLATION:
      case constants.RECURRING_DATA_TRANSFER:
        return licenseName + " (契約容量)";
      case constants.CHARGE_TRANSLATION:
      case constants.CHARGE_SPEECH_TEXT:
      case constants.CHARGE_DATA_TRANSFER:
        return licenseName + " (チャージ容量)";
      default:
        return licenseName;
    }
  },

  // get display name of plan.
  getPlanName(planType) {
    switch (planType) {
      case constants.LICENSE_PLAN_STANDARD:
        return this.getMessageText(i18n, "item_licenseName_voice");
      case constants.LICENSE_PLAN_TALK_LITE:
        return "Talk Lite";
      case constants.LICENSE_PLAN_TALK_ENT:
        return "Talk Enterprise";
      case constants.LICENSE_PLAN_LIVE_LITE:
        return "Livecast Lite";
      case constants.LICENSE_PLAN_LIVE_ENT:
        return "Livecast Enterprise";
      default:
        return null;
    }
  },

  // get display name of unit.
  getUnitName(i18n, licenseType) {
    switch (Number(licenseType)) {
      case constants.RECURRING_SPEECH_TEXT:
      case constants.CHARGE_SPEECH_TEXT:
        return this.getMessageText(i18n, "unit_sec");
      case constants.RECURRING_TRANSLATION:
      case constants.CHARGE_TRANSLATION:
        return this.getMessageText(i18n, "unit_character");
      case constants.RECURRING_DATA_TRANSFER:
      case constants.CHARGE_DATA_TRANSFER:
        return this.getMessageText(i18n, "unit_gigabyte");
      default:
        return null;
    }
  },
  getUnitNameForCurrent(i18n, licenseType) {
    switch (Number(licenseType)) {
      case constants.RECURRING_SPEECH_TEXT:
      case constants.CHARGE_SPEECH_TEXT:
        return this.getMessageText(i18n, "unit_sec");
      case constants.RECURRING_TRANSLATION:
      case constants.CHARGE_TRANSLATION:
        return this.getMessageText(i18n, "unit_character");
      case constants.RECURRING_DATA_TRANSFER:
      case constants.CHARGE_DATA_TRANSFER:
        return this.getMessageText(i18n, "unit_byte");
      default:
        return null;
    }
  },

  // get display name of privilege.
  getPrivilegeDisplayName(i18n, privilege) {
    switch (privilege) {
      case constants.RESTRICTION_LOGOUT:
        return this.getMessageText(i18n, "item_logout");
      case constants.RESTRICTION_PEER_TO_PEER:
        return this.getMessageText(i18n, "item_individual_talk");
      case constants.RESTRICTION_MAP_TAB:
        return this.getMessageText(i18n, "item_map_tab");
      case constants.RESTRICTION_CHAT_TAB:
        return this.getMessageText(i18n, "item_chat_tab");
      case constants.RESTRICTION_CHAT_SEND:
        return this.getMessageText(i18n, "item_chat_send");
      case constants.PRIVILEGE_TENANT_ADMIN:
        return this.getMessageText(i18n, "item_tenant_management");
      case constants.PRIVILEGE_RADIO_MANAGE:
        return this.getMessageText(i18n, "item_radio_manage");
      case constants.PRIVILEGE_ALERT:
        return this.getMessageText(i18n, "item_send_alert");
      case constants.RESTRICTION_SAVE_CONTENTS:
        return this.getMessageText(i18n, "item_save_contents");
      case constants.RESTRICTION_MODIFY_NAME:
        return this.getMessageText(i18n, "item_modify_name");
      case constants.PRIVILEGE_FORCE_STOP_VOICE_REPORT:
        return this.getMessageText(i18n, "item_force_stop_voice_report");
    }
  },

  getLinkTenantTreeData(i18n) {
    return [
      {
        label: this.getMessageText(i18n, "title_desc_link_tenant1"),
        type: constants.SETTING_INTER_COMPANY_IMPORT,
        isLeaf: true,
      },
      {
        label: this.getMessageText(i18n, "title_desc_link_tenant2"),
        type: constants.SETTING_INTER_COMPANY_EXPORT,
        isLeaf: true,
      },
    ];
  },

  // get add/diff unit of license.
  getLicenseUnit(licenseType) {
    var licenseUnit = 0;
    switch (licenseType) {
      case constants.LICENSE_USER:
      case constants.LICENSE_SPEECH_TEXT:
      case constants.LICENSE_TRANSLATION:
      case constants.LICENSE_CONFIG:
      case constants.LICENSE_ACCESS_LOG:
      case constants.LICENSE_TRACKING:
      case constants.LICENSE_MAP_TALK:
      case constants.LICENSE_HISTORY_RETENTION:
      case constants.LICENSE_HISTORY_RETENTION_ADVANCED:
      case constants.LICENSE_HISTORY_RETENTION_TRACKING:
      case constants.LICENSE_VIDEO:
      case constants.LICENSE_SAML:
      case constants.OFF_PLAN_LICENSE_BELL:
      case constants.OFF_PLAN_LICENSE_DEDICATED:
      case constants.OFF_PLAN_LICENSE_BUDDY_BOT_API:
      case constants.OFF_PLAN_LICENSE_CALL:
      case constants.RECURRING_DATA_TRANSFER:
      case constants.CHARGE_DATA_TRANSFER:
        licenseUnit = 1;
        break;
      case constants.RECURRING_SPEECH_TEXT:
      case constants.CHARGE_SPEECH_TEXT:
        licenseUnit = constants.PURCHASE_UNIT_SPEECH_TEXT;
        break;
      case constants.RECURRING_TRANSLATION:
      case constants.CHARGE_TRANSLATION:
        licenseUnit = constants.PURCHASE_UNIT_TRANSLATE;
        break;
    }
    return licenseUnit;
  },

  // get display name of currency.
  getCurrencyDisplayName(currencyValue) {
    for (let currency of this.getCurrencyList()) {
      if (currency.value == currencyValue) {
        return currency.displayName;
      }
    }
    return null;
  },

  isChargeLicense(licenseType) {
    switch (Number(licenseType)) {
      case constants.CHARGE_SPEECH_TEXT:
      case constants.CHARGE_TRANSLATION:
      case constants.CHARGE_DATA_TRANSFER:
        return true;
      default:
        return false;
    }
  },

  // get display name of autoStart setting.
  getAutoStartMode(i18n, autoStart) {
    var autoStartMode;
    switch (autoStart) {
      case 0:
        autoStartMode = this.getMessageText(i18n, "value_on");
        break;
      case 1:
        autoStartMode = this.getMessageText(i18n, "value_off");
        break;
    }
    return autoStartMode;
  },

  // get display name of button mode setting.
  getButtonMode(i18n, buttonMode) {
    var buttonModeName;
    switch (buttonMode) {
      case 0:
        buttonModeName = this.getMessageText(i18n, "value_hold");
        break;
      case 1:
        buttonModeName = this.getMessageText(i18n, "value_toggle");
        break;
    }
    return buttonModeName;
  },

  getPurchasePeriodTypeName(i18n, purchasePeriodTypeValue, contractStatus = null) {
    switch (purchasePeriodTypeValue) {
      case constants.PURCHASE_PERIOD_MONTHLY:
        return this.getMessageText(i18n, "item_contractType_monthly");
      case constants.PURCHASE_PERIOD_YEARLY:
        return this.getMessageText(i18n, "item_contractType_yearly");
      case constants.PURCHASE_PERIOD_TRIAL:
        if (Number(contractStatus) === constants.CONTRACT_APPLESS) {
          return this.getMessageText(i18n, "item_contract_appless");
        }
        return this.getMessageText(i18n, "item_contractType_trial");
      default:
        return null;
    }
  },

  getPlanTypeName(i18n, planTypeValue) {
    switch (planTypeValue) {
      case constants.LICENSE_PLAN_SEPARATE:
        return this.getMessageText(i18n, "item_planType_separate");
      case constants.LICENSE_PLAN_LITE:
        return this.getMessageText(i18n, "item_planType_light");
      case constants.LICENSE_PLAN_STANDARD:
        return this.getMessageText(i18n, "item_planType_standard");
      case constants.LICENSE_PLAN_ENTERPRISE:
        return this.getMessageText(i18n, "item_planType_enterprise");
      case constants.LICENSE_PLAN_TALK_LITE:
        return this.getMessageText(i18n, "item_planType_talk_lite");
      case constants.LICENSE_PLAN_TALK_ENT:
        return this.getMessageText(i18n, "item_planType_talk_enterprise");
      case constants.LICENSE_PLAN_LIVE_LITE:
        return this.getMessageText(i18n, "item_planType_livecast_lite");
      case constants.LICENSE_PLAN_LIVE_ENT:
        return this.getMessageText(i18n, "item_planType_livecast_enterprise");
      default:
        return null;
    }
  },

  getGraceUnitDisplayName(graceUnitValue) {
    for (let graceUnit of this.getGraceUnitList()) {
      if (graceUnit.value == graceUnitValue) {
        return graceUnit.displayName;
      }
    }
    return null;
  },

  getContractStatusName(i18n, contractStatus) {
    var contractStatusName;
    switch (Number(contractStatus)) {
      case constants.CONTRACT_ACTIVE:
        contractStatusName = this.getMessageText(i18n, "item_contract_auto");
        break;
      case constants.CONTRACT_NOUPDATE:
        contractStatusName = this.getMessageText(i18n, "item_contract_stop_auto");
        break;
      case constants.CONTRACT_TERMINATE:
        contractStatusName = this.getMessageText(i18n, "item_contract_terminate");
        break;
      case constants.CONTRACT_ACTIVATING:
        contractStatusName = this.getMessageText(i18n, "item_contract_active");
        break;
      case constants.CONTRACT_TRIAL:
        contractStatusName = this.getMessageText(i18n, "item_contract_trial");
        break;
      case constants.CONTRACT_TRIAL_END:
        contractStatusName = this.getMessageText(i18n, "item_contract_trial_end");
        break;
      case constants.CONTRACT_DEVELOPMENT:
        contractStatusName = this.getMessageText(i18n, "item_contract_development");
        break;
      case constants.CONTRACT_DISABLED:
        contractStatusName = this.getMessageText(i18n, "item_contract_disabled");
        break;
      case constants.CONTRACT_PAID_REVIEW:
        contractStatusName = this.getMessageText(i18n, "item_contract_paid_review");
        break;
      case constants.CONTRACT_APPLESS:
        contractStatusName = this.getMessageText(i18n, "item_contract_appless");
        break;
    }
    return contractStatusName;
  },

  getBillingTypeName(billingTypeValue) {
    for (let billingType of this.getBillingTypeList()) {
      if (billingType.value == billingTypeValue) {
        return billingType.displayName;
      }
    }
    return null;
  },

  getNextFlushDate(startDate, plusMonth, offset) {
    // javascript creates Date object as local time.
    // time should calculate local time with offset of tenant.
    let localStartDateTime = new Date(startDate);
    let localNextFlushDateTime = new Date(startDate);
    let currentOffset = (localStartDateTime.getTimezoneOffset() / 60) * 60 * 60 * 1000;
    let tenantOffset = offset * 60 * 60 * 1000;

    localStartDateTime.setTime(localStartDateTime.getTime() + currentOffset);
    localStartDateTime.setTime(localStartDateTime.getTime() + tenantOffset);

    localNextFlushDateTime.setTime(localNextFlushDateTime.getTime() + currentOffset);
    localNextFlushDateTime.setTime(localNextFlushDateTime.getTime() + tenantOffset);

    localNextFlushDateTime.setMonth(localNextFlushDateTime.getMonth() + plusMonth);

    // adjusting last day of month.
    if (localNextFlushDateTime.getMonth() - localStartDateTime.getMonth() > 1) {
      localNextFlushDateTime.setDate(0);
    }

    return localNextFlushDateTime;
  },

  getNextFlushDateName(i18n, contractStatus) {
    var nextFlushDateName;
    switch (Number(contractStatus)) {
      case constants.CONTRACT_ACTIVE:
        nextFlushDateName = this.getMessageText(i18n, "item_contract_renewal_date");
        break;
      case constants.CONTRACT_NOUPDATE:
      case constants.CONTRACT_TERMINATE:
      case constants.CONTRACT_DEVELOPMENT:
        nextFlushDateName = this.getMessageText(i18n, "item_contract_terminate_date");
        break;
      case constants.CONTRACT_TRIAL:
      case constants.CONTRACT_TRIAL_END:
        nextFlushDateName = this.getMessageText(i18n, "item_contract_end_date");
        break;
      case constants.CONTRACT_PAID_REVIEW:
        nextFlushDateName = this.getMessageText(i18n, "item_contract_start_date");
        break;
      case constants.CONTRACT_APPLESS:
        nextFlushDateName = this.getMessageText(i18n, "item_contract_appless");
        break;
    }
    return nextFlushDateName;
  },
  getPurchaseContractActionName(i18n, contractState) {
    let contractActionName;
    switch (contractState) {
      case constants.CONTRACT_ACTIVE:
        contractActionName = this.getMessageText(i18n, "action_contract_no_update");
        break;
      case constants.CONTRACT_NOUPDATE:
        contractActionName = this.getMessageText(i18n, "action_contract_auto_update");
        break;
    }
    return contractActionName;
  },

  // get display name of link status.
  getLinkStatusName(i18n, type, linkStatus) {
    switch (Number(linkStatus)) {
      case constants.TENANT_CONNECT_WANT:
        return type === "import"
          ? this.getMessageText(i18n, "item_link_status_sent")
          : this.getMessageText(i18n, "item_link_status_received");
      case constants.TENANT_CONNECT_ALLOW:
        return type === "import"
          ? this.getMessageText(i18n, "item_link_status_received")
          : this.getMessageText(i18n, "item_link_status_sent");
      case constants.TENANT_CONNECT_ESTABLISH:
        return this.getMessageText(i18n, "item_link_status_linked");
      default:
        return "";
    }
  },

  getSettingDescription(settingDefinition, definitionName, value) {
    let setting = settingDefinition[definitionName];
    if (value == null) {
      return setting.description;
    } else {
      for (let param of setting["values"]) {
        if (param.value == value) {
          return param.description;
        }
      }
    }
    return null;
  },

  getMenuItems() {
    return [
      { name: "user", link: "/", label: "menu_user_group", badge: 0 },
      { name: "talk", link: "/talk", label: "menu_talk_record", badge: 0 },
      { name: "map", link: "/map", label: "menu_tracking", badge: 0 },
      { name: "bell", link: "/bell", label: "menu_bell", badge: 0 },
      { name: "restrictions", link: "/restrictions", label: "menu_restrictions", badge: 0 },
      { name: "keyvault", link: "/keyvault", label: "menu_key_vault", badge: 0 },
      { name: "setting", link: "/setting", label: "menu_setting", badge: 0 },
      { name: "radio", link: "/radio", label: "menu_radio", badge: 0 },
      { name: "manual", link: "/manual", label: "menu_manual", badge: 0 },
      { name: "license", link: "/license", label: "menu_license", badge: 0 },
      { name: "auditlog", link: "/auditlog", label: "menu_audit", badge: 0 },
    ];
  },
  getLicenseList(i18n) {
    return [
      {
        value: constants.LICENSE_USER,
        displayName: this.getMessageText(i18n, "item_licenseName_voice"),
      },
      {
        value: constants.LICENSE_SPEECH_TEXT,
        displayName: this.getMessageText(i18n, "item_licenseName_speechToText"),
      },
      {
        value: constants.LICENSE_TRANSLATION,
        displayName: this.getMessageText(i18n, "item_licenseName_translation"),
      },
      {
        value: constants.LICENSE_CONFIG,
        displayName: this.getMessageText(i18n, "item_licenseName_setting"),
      },
      {
        value: constants.LICENSE_TRACKING,
        displayName: this.getMessageText(i18n, "item_licenseName_locationTrack"),
      },
      {
        value: constants.LICENSE_MAP_TALK,
        displayName: this.getMessageText(i18n, "item_licenseName_mapTalk"),
      },
      {
        value: constants.LICENSE_ACCESS_LOG,
        displayName: this.getMessageText(i18n, "item_licenseName_audit"),
      },
      {
        value: constants.LICENSE_HISTORY_RETENTION,
        displayName: this.getMessageText(i18n, "item_licenseName_history"),
      },
      {
        value: constants.LICENSE_HISTORY_RETENTION_ADVANCED,
        displayName: this.getMessageText(i18n, "item_licenseName_history_advanced"),
      },
      {
        value: constants.LICENSE_HISTORY_RETENTION_TRACKING,
        displayName: this.getMessageText(i18n, "item_licenseName_history_tracking"),
      },
      {
        value: constants.LICENSE_VIDEO,
        displayName: this.getMessageText(i18n, "item_licenseName_video"),
      },
      {
        value: constants.LICENSE_SAML,
        displayName: this.getMessageText(i18n, "item_licenseName_saml"),
      },
      {
        value: constants.RECURRING_SPEECH_TEXT,
        displayName: this.getMessageText(i18n, "item_licenseName_speechToText"),
      },
      {
        value: constants.RECURRING_TRANSLATION,
        displayName: this.getMessageText(i18n, "item_licenseName_translation"),
      },
      {
        value: constants.RECURRING_DATA_TRANSFER,
        displayName: this.getMessageText(i18n, "item_licenseName_dataTransfer"),
      },
      {
        value: constants.CHARGE_SPEECH_TEXT,
        displayName: this.getMessageText(i18n, "item_licenseName_speechToText"),
      },
      {
        value: constants.CHARGE_TRANSLATION,
        displayName: this.getMessageText(i18n, "item_licenseName_translation"),
      },
      {
        value: constants.CHARGE_DATA_TRANSFER,
        displayName: this.getMessageText(i18n, "item_licenseName_dataTransfer"),
      },
    ];
  },
  getOffPlanLicenseList(i18n) {
    return [
      {
        value: constants.OFF_PLAN_LICENSE_BELL,
        displayName: this.getMessageText(i18n, "item_licenseName_bell"),
      },
      {
        value: constants.OFF_PLAN_LICENSE_CALL,
        displayName: this.getMessageText(i18n, "item_licenseName_call"),
      },
      {
        value: constants.OFF_PLAN_LICENSE_DEDICATED,
        displayName: this.getMessageText(i18n, "item_licenseName_dedicated"),
      },
      {
        value: constants.OFF_PLAN_LICENSE_CALL_CENTER,
        displayName: this.getMessageText(i18n, "item_licenseName_call_center"),
      },
      {
        value: constants.OFF_PLAN_LICENSE_BUDDY_BOT_API,
        displayName: this.getMessageText(i18n, "item_licenseName_buddybotApi"),
      },
      {
        value: constants.OFF_PLAN_LICENSE_MAP_IMAGE_OVERLAY,
        displayName: this.getMessageText(i18n, "item_licenseName_map_image_overlay"),
      },
      {
        value: constants.OFF_PLAN_LICENSE_SAFETY_SUPPORT,
        displayName: this.getMessageText(i18n, "item_licenseName_safety_support"),
      },
    ];
  },
  getLicensePlanList() {
    return [
      // old plan
      { value: constants.LICENSE_PLAN_LITE, displayName: "Light plan" },
      { value: constants.LICENSE_PLAN_STANDARD, displayName: "Standard plan" },
      { value: constants.LICENSE_PLAN_ENTERPRISE, displayName: "Enterprise plan" },
      // current plan
      { value: constants.LICENSE_PLAN_TALK_LITE, displayName: "Talk Lite" },
      { value: constants.LICENSE_PLAN_TALK_ENT, displayName: "Talk Enterprise" },
      { value: constants.LICENSE_PLAN_LIVE_LITE, displayName: "Livecast Lite" },
      { value: constants.LICENSE_PLAN_LIVE_ENT, displayName: "Livecast Enterprise" },
    ];
  },
  getLicenseListForEndUser(i18n) {
    return [
      {
        value: constants.LICENSE_USER,
        displayName: this.getMessageText(i18n, "item_licenseName_voice"),
      },
      {
        value: constants.LICENSE_SPEECH_TEXT,
        displayName: this.getMessageText(i18n, "item_licenseName_speechToText"),
      },
      //            { value: constants.LICENSE_TRANSLATION , displayName: this.getMessageText(i18n,"item_licenseName_translation") },
      //            { value: constants.LICENSE_CONFIG , displayName: this.getMessageText(i18n,"item_licenseName_setting") },
      //            { value: constants.LICENSE_ACCESS_LOG , displayName: this.getMessageText(i18n,"item_licenseName_audit") },
      //            { value: constants.LICENSE_TRACKING , displayName: this.getMessageText(i18n,"item_licenseName_locationTrack") },
      //            { value: constants.LICENSE_MAP_TALK , displayName: this.getMessageText(i18n,"item_licenseName_mapTalk") },
      //            { value: constants.LICENSE_VIDEO , displayName: this.getMessageText(i18n,"item_licenseName_video") },
      //            { value: constants.LICENSE_SAML , displayName: this.getMessageText(i18n,"item_licenseName_saml") },
      {
        value: constants.RECURRING_SPEECH_TEXT,
        displayName: this.getMessageText(i18n, "item_licenseName_speechToText"),
      },
      //            { value: constants.RECURRING_TRANSLATION , displayName: this.getMessageText(i18n,"item_licenseName_translation") },
      //            { value: constants.RECURRING_DATA_TRANSFER , displayName: this.getMessageText(i18n,"item_licenseName_dataTransfer") },
      {
        value: constants.CHARGE_SPEECH_TEXT,
        displayName: this.getMessageText(i18n, "item_licenseName_speechToText"),
      },
      //            { value: constants.CHARGE_TRANSLATION , displayName: this.getMessageText(i18n,"item_licenseName_translation") },
      //            { value: constants.CHARGE_VIDEO , displayName: this.getMessageText(i18n,"item_licenseName_dataTransfer") }
    ];
  },
  getUserOption(i18n) {
    return [
      { name: this.getMessageText(i18n, "item_option_speechToText"), shift: 0 },
      { name: this.getMessageText(i18n, "item_option_translation"), shift: 1 },
      { name: this.getMessageText(i18n, "item_option_video"), shift: 2 },
      { name: this.getMessageText(i18n, "item_option_location_tracking"), shift: 3 },
      { name: this.getMessageText(i18n, "item_option_map_talk"), shift: 4 },
    ];
  },
  getUserOptionForOnline(i18n) {
    return [
      { name: this.getMessageText(i18n, "item_option_speechToText"), shift: 0 },
      { name: this.getMessageText(i18n, "item_option_translation"), shift: 1 },
      //            { name: this.getMessageText(i18n,"item_option_video"), shift: 2},
      //            { name: this.getMessageText(i18n,"item_option_location_tracking"), shift: 3},
      { name: this.getMessageText(i18n, "item_option_map_talk"), shift: 4 },
    ];
  },
  getTalkgroupOption(i18n) {
    return [
      //        { name: "割込み通話", shift: 0},
      {
        name: this.getMessageText(i18n, "item_option_fullDuplexCall"),
        shift: constants.TALKGROUP_OPTION_MULTI_TALK,
      },
      //        { name: "双方向通話（帯域優先）", shift: 2},
      {
        name: this.getMessageText(i18n, "item_option_location_information"),
        shift: constants.TALKGROUP_OPTION_LOCATION,
      },
      {
        name: this.getMessageText(i18n, "item_option_map_talk"),
        shift: constants.TALKGROUP_OPTION_MAP_TALK,
      },
      {
        name: this.getMessageText(i18n, "item_option_speechToText"),
        shift: constants.TALKGROUP_OPTION_SPEECH_TEXT,
      },
      {
        name: this.getMessageText(i18n, "item_option_translation"),
        shift: constants.TALKGROUP_OPTION_TRANSLATION,
      },
      {
        name: this.getMessageText(i18n, "item_option_video"),
        shift: constants.TALKGROUP_OPTION_VIDEO,
      },
      //        { name: "必須グループ", shift: constants.TALKGROUP_OPTION_MANDATORY}
    ];
  },
  getTalkgroupOptionAvailableForE2EEncryption(i18n) {
    return [
      //        { name: "割込み通話", shift: 0},
      {
        name: this.getMessageText(i18n, "item_option_fullDuplexCall"),
        shift: constants.TALKGROUP_OPTION_MULTI_TALK,
      },
      //        { name: "双方向通話（帯域優先）", shift: 2},
      {
        name: this.getMessageText(i18n, "item_option_location_information"),
        shift: constants.TALKGROUP_OPTION_LOCATION,
      },
      {
        name: this.getMessageText(i18n, "item_option_speechToText"),
        shift: constants.TALKGROUP_OPTION_SPEECH_TEXT,
      },
      {
        name: this.getMessageText(i18n, "item_option_translation"),
        shift: constants.TALKGROUP_OPTION_TRANSLATION,
      },
      //        { name: this.getMessageText(i18n,"item_option_video"), shift: constants.TALKGROUP_OPTION_VIDEO},
      {
        name: this.getMessageText(i18n, "item_option_map_talk"),
        shift: constants.TALKGROUP_OPTION_MAP_TALK,
      },
      //        { name: "必須グループ", shift: constants.TALKGROUP_OPTION_MANDATORY}
    ];
  },
  getAuditFunctionList() {
    return [
      { name: "ALL", displayName: "すべての機能" },
      { name: "RegisterTenant", displayName: "テナント登録" },
      { name: "ModifyTenant", displayName: "テナント情報変更" },
      { name: "ModifyTenantDetail", displayName: "テナントオプション変更" },
      { name: "DeleteTenant", displayName: "テナント削除" },
      { name: "DisableTenant", displayName: "テナント無効化" },
      { name: "EnableTenant", displayName: "テナント有効化" },
      { name: "ModifyPartnerOfTenant", displayName: "テナントのパートナー変更" },
      { name: "CreateDeferredProcessInfo", displayName: "契約変更リクエスト登録" },
      { name: "ModifyDeferredProcessInfo", displayName: "契約変更リクエスト変更" },
      { name: "DeleteDeferredProcessInfo", displayName: "契約変更リクエスト削除" },
      { name: "ModifyPlanType", displayName: "ライセンスプラン変更" },
      { name: "ModifyLicense", displayName: "ライセンス変更" },
      { name: "ModifyFreeLicense", displayName: "無償ライセンス変更" },
      { name: "ModifyBasicContract", displayName: "自動更新変更 / Flushingリセット" },
      { name: "ModifyTenantState", displayName: "契約状態変更" },
      { name: "ModifyTrialPeriod", displayName: "トライアル期間変更" },
      { name: "ChangeCarryoverOption", displayName: "繰り越し停止オプション変更" },
      { name: "AddTenantMailDestination", displayName: "通知メールアドレス先追加" },
      { name: "ModifyTenantMailDestination", displayName: "通知メールアドレス先変更" },
      { name: "DeleteTenantMailDestination", displayName: "通知メールアドレス先削除" },
      { name: "CreatePartner", displayName: "パートナー作成" },
      { name: "ModifyPartner", displayName: "パートナー情報変更" },
      { name: "DeletePartner", displayName: "パートナー削除" },
      { name: "CreatePartnerUser", displayName: "管理ユーザー作成" },
      { name: "ModifyPartnerUser", displayName: "管理ユーザー情報変更" },
      { name: "DeletePartnerUser", displayName: "管理ユーザー削除" },
      { name: "Login", displayName: "ログイン" },
      { name: "CreateServerGroup", displayName: "サーバーグループ追加" },
      { name: "RegisterApiToken", displayName: "APIトークン登録" },
      { name: "CreateCertifiedDevice", displayName: "周辺機器登録の追加" },
      { name: "DeleteCertifiedDevice", displayName: "周辺機器登録の削除" },
      { name: "EditCertifiedDevice", displayName: "周辺機器登録の編集" },
      { name: "CreatePeripheralDevice", displayName: "正式サポート機器登録の追加" },
      { name: "DeletePeripheralDevice", displayName: "正式サポート機器登録の削除" },
      { name: "EditPeripheralDevice", displayName: "正式サポート機器登録の編集" },
      {
        name: "RegisterTenantFromDealerConsole",
        displayName: "テナント登録（ディーラーコンソール）",
      },
    ];
  },
  getAuditFunctionListForTenant(i18n, onlinePurchase) {
    let functionList = [
      { name: "ALL", displayName: this.getMessageText(i18n, "item_function_all") },
      { name: "Login", displayName: this.getMessageText(i18n, "item_function_login") },
      {
        name: "Login2ndPhase",
        displayName: this.getMessageText(i18n, "item_function_login_two_phase"),
      },
      {
        name: "BellLogin",
        displayName: this.getMessageText(i18n, "item_function_login_bell_dashboard"),
      },
      { name: "AuthLogin", displayName: this.getMessageText(i18n, "item_function_login_auth") },
      { name: "GetURL", displayName: this.getMessageText(i18n, "item_function_group_talk_record") },
      {
        name: "GetPeerURL",
        displayName: this.getMessageText(i18n, "item_function_peer_talk_record"),
      },
      {
        name: "GetTalkrecords",
        displayName: this.getMessageText(i18n, "item_function_group_talk_record_list"),
      },
      {
        name: "GetPeerTalkrecords",
        displayName: this.getMessageText(i18n, "item_function_peer_talk_record_list"),
      },
      {
        name: "TalkrecordsCSVExportAuditLog",
        displayName: this.getMessageText(i18n, "item_function_group_talk_record_csv_export"),
      },
      {
        name: "ModifyPermitIPAddressList",
        displayName: this.getMessageText(i18n, "title_setting_permit_ip_address"),
      },
      {
        name: "ModifyClientPermitIPAddressList",
        displayName: this.getMessageText(i18n, "title_setting_client_permit_ip_address"),
      },
      {
        name: "TwoPhaseMethod",
        displayName: this.getMessageText(i18n, "item_function_two_phase_method"),
      },
      {
        name: "DeviceManagement",
        displayName: this.getMessageText(i18n, "item_function_device_management"),
      },
      {
        name: "ModifyConsole2FA",
        displayName: this.getMessageText(i18n, "title_reset_two_phase_auth_other"),
      },
      {
        name: "ModifyEnableConsole2FA",
        displayName: this.getMessageText(i18n, "title_switch_enable_two_phase_auth"),
      },
      {
        name: "IssueIpRadioIntegrationToken",
        displayName: this.getMessageText(i18n, "item_function_radio_integrate"),
      },
    ];
    if (onlinePurchase) {
      functionList.push({
        name: "PurchaseLicense",
        displayName: this.getMessageText(i18n, "item_function_license"),
      });
      functionList.push({
        name: "OnlinePurchaseCompensate",
        displayName: this.getMessageText(i18n, "item_function_license"),
      });
      functionList.push({
        name: "ModifyContractStatus",
        displayName: this.getMessageText(i18n, "item_function_contract_renewal"),
      });
      functionList.push({
        name: "CreateDeferredProcessInfo",
        displayName: this.getMessageText(i18n, "item_function_contract_req_reg"),
      });
      functionList.push({
        name: "DeleteDeferredProcessInfo",
        displayName: this.getMessageText(i18n, "item_function_contract_req_del"),
      });
    }
    // TODO: FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY toggle削除後はfunctionListの初期化に含める
    if (FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY) {
      let targetIndex = functionList.findIndex((item) => item.name == "GetPeerTalkrecords") + 1;
      functionList.splice(targetIndex, 0, {
        name: "GetBuddycomCallRecords",
        displayName: this.getMessageText(i18n, "item_function_buddycom_call_talk_record_list"),
      });
    }
    return functionList;
  },
  // 選択ボックスの選択肢一覧用
  getAuditFunctionCategoryListForTenant(i18n, onlinePurchase) {
    let functionList = [
      { name: "ALL", displayName: this.getMessageText(i18n, "item_function_all") },
      { name: "Login", displayName: this.getMessageText(i18n, "item_function_login") },
      {
        name: "BellLogin",
        displayName: this.getMessageText(i18n, "item_function_login_bell_dashboard"),
      },
      { name: "AuthLogin", displayName: this.getMessageText(i18n, "item_function_login_auth") },
      { name: "GetURL", displayName: this.getMessageText(i18n, "item_function_group_talk_record") },
      {
        name: "GetPeerURL",
        displayName: this.getMessageText(i18n, "item_function_peer_talk_record"),
      },
      {
        name: "GetTalkrecords",
        displayName: this.getMessageText(i18n, "item_function_group_talk_record_list"),
      },
      {
        name: "GetPeerTalkrecords",
        displayName: this.getMessageText(i18n, "item_function_peer_talk_record_list"),
      },
      {
        name: "TalkrecordsCSVExportAuditLog",
        displayName: this.getMessageText(i18n, "item_function_group_talk_record_csv_export"),
      },
      {
        name: "ModifyPermitIPAddressList",
        displayName: this.getMessageText(i18n, "title_setting_permit_ip_address"),
      },
      ...(FEATURE_BD_1939_IP_RESTRICTION
        ? [
          {
            name: "ModifyClientPermitIPAddressList",
            displayName: this.getMessageText(i18n, "title_setting_client_permit_ip_address"),
          },
        ]
        : []),
      {
        name: "TwoPhaseMethod",
        displayName: this.getMessageText(i18n, "item_function_two_phase_method"),
      },
      {
        name: "DeviceManagement",
        displayName: this.getMessageText(i18n, "item_function_device_management"),
      },
      {
        name: "ModifyConsole2FA",
        displayName: this.getMessageText(i18n, "title_reset_two_phase_auth_other"),
      },
      {
        name: "ModifyEnableConsole2FA",
        displayName: this.getMessageText(i18n, "title_switch_enable_two_phase_auth"),
      },
      { name: "ApplicationControl", displayName: this.getMessageText(i18n, "title_app_control") },
      {
        name: "IssueIpRadioIntegrationToken",
        displayName: this.getMessageText(i18n, "item_function_radio_integrate"),
      },
    ];
    if (onlinePurchase) {
      functionList.push({
        name: "PurchaseLicense",
        displayName: this.getMessageText(i18n, "item_function_license"),
      });
      functionList.push({
        name: "OnlinePurchaseCompensate",
        displayName: this.getMessageText(i18n, "item_function_license"),
      });
      functionList.push({
        name: "ModifyContractStatus",
        displayName: this.getMessageText(i18n, "item_function_contract_renewal"),
      });
      functionList.push({
        name: "CreateDeferredProcessInfo",
        displayName: this.getMessageText(i18n, "item_function_contract_req_reg"),
      });
      functionList.push({
        name: "DeleteDeferredProcessInfo",
        displayName: this.getMessageText(i18n, "item_function_contract_req_del"),
      });
    }
    if (!FEATURE_C2C_AUDIT_LOG) {
      functionList = functionList.filter((f) => f.name !== "TalkrecordsCSVExportAuditLog");
    }
    // TODO: FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY toggle削除後はfunctionListの初期化に含める
    if (FEATURE_BD_2191_FIX_CALL_RECORD_DISPLAY) {
      let targetIndex = functionList.findIndex((item) => item.name == "GetPeerTalkrecords") + 1;
      functionList.splice(targetIndex, 0, {
        name: "GetBuddycomCallRecords",
        displayName: this.getMessageText(i18n, "item_function_buddycom_call_talk_record_list"),
      });
    }
    return functionList;
  },
  getAuditFunctionListOfOnlinePurchase(i18n) {
    let functionList = [
      { name: "ALL", displayName: this.getMessageText(i18n, "item_function_all") },
      { name: "PurchaseLicense", displayName: this.getMessageText(i18n, "item_function_license") },
      {
        name: "ModifyContractStatus",
        displayName: this.getMessageText(i18n, "item_function_contract_renewal"),
      },
      {
        name: "CreateDeferredProcessInfo",
        displayName: this.getMessageText(i18n, "item_function_contract_req_reg"),
      },
      {
        name: "DeleteDeferredProcessInfo",
        displayName: this.getMessageText(i18n, "item_function_contract_req_del"),
      },
    ];
    return functionList;
  },
  getTenantSearchConditionList() {
    return [
      { value: constants.SEARCH_CONDITION_COMPANY_PARTIAL, label: "法人名（部分一致）" },
      { value: constants.SEARCH_CONDITION_COMPANY_ALL, label: "法人名（完全一致）" },
      { value: constants.SEARCH_CONDITION_TENANT_PARTIAL, label: "テナント名（部分一致）" },
      { value: constants.SEARCH_CONDITION_TENANT_ALL, label: "テナント名（完全一致）" },
      { value: constants.SEARCH_CONDITION_TENANT_ID, label: "テナントID" },
    ];
    return functionList;
  },
  getSubGroupInfoTypeList(i18n) {
    return [
      {
        value: constants.SUB_GROUP_INFO_DESTINATIONS,
        label: this.getMessageText(i18n, "title_destination_sub_group"),
      },
      {
        value: constants.SUB_GROUP_INFO_USERS,
        label: this.getMessageText(i18n, "title_participating_user"),
      },
    ];
  },
  getObjectTreeTypeOrder() {
    return {
      [constants.OBJECT_NODE]: 0,
      [constants.OBJECT_ASSISTANT]: 1,
      [constants.OBJECT_USER]: 2,
      [constants.OBJECT_IP_RADIO]: 3,
      [constants.OBJECT_TALKGROUP]: 4,
      [constants.OBJECT_BUDDYCOM_CALL_USER]: 5,
    };
  },
  isVisibleUserOption(onlinePurchase, optionName) {
    if (onlinePurchase) {
      switch (optionName) {
        case "speechToText":
        case "mapTalk":
          return true;
        case "translation":
        case "tracking":
        case "video":
          return false;
      }
    } else {
      switch (optionName) {
        case "speechToText":
        case "translation":
        case "tracking":
        case "mapTalk":
        case "video":
          return true;
      }
    }
  },
  isVisibleGroupOption(onlinePurchase, optionName) {
    if (onlinePurchase) {
      switch (optionName) {
        case "translationEngine":
        case "video":
          return false;
        default:
          return true;
      }
    } else {
      return true;
    }
  },
  isVideo(type, data) {
    if (data == null) {
      return false;
    }
    if (type != constants.TALK_RECORD_BINARY) {
      return false;
    }
    let index = data.indexOf(":");
    if (index < 0) {
      return false;
    }
    let prefix = data.substr(0, index);
    return constants.OFFLOAD_DATA_VIDEO.has(prefix);
  },
  isImage(type, data) {
    if (data == null) {
      return false;
    }
    if (type != constants.TALK_RECORD_BINARY) {
      return false;
    }
    let index = data.indexOf(":");
    if (index < 0) {
      return false;
    }
    let prefix = data.substr(0, index);
    return constants.OFFLOAD_DATA_IMAGE.has(prefix);
  },
  isPDF(type, data) {
    if (data == null) {
      return false;
    }
    if (type !== constants.TALK_RECORD_BINARY) {
      return false;
    }
    const index = data.indexOf(":");
    if (index < 0) {
      return false;
    }
    return data.substring(0, index) === "PDF";
  },
  getContentQueryParam(purchaseType) {
    if (purchaseType == constants.PURCHASE_PERIOD_TRIAL) {
      return "?type=trial";
    } else {
      return "?type=purchase";
    }
  },
  getPurchasePeriodTypeList(i18n) {
    return [
      {
        value: constants.PURCHASE_PERIOD_MONTHLY,
        displayName: this.getMessageText(i18n, "item_contractType_monthly"),
      },
      {
        value: constants.PURCHASE_PERIOD_YEARLY,
        displayName: this.getMessageText(i18n, "item_contractType_yearly"),
      },
      {
        value: constants.PURCHASE_PERIOD_TRIAL,
        displayName: this.getMessageText(i18n, "item_contractType_trial"),
      },
    ];
  },
  getAllPlanTypeList(i18n) {
    return [
      {
        value: constants.LICENSE_PLAN_SEPARATE,
        displayName: this.getMessageText(i18n, "item_planType_separate"),
      },
      {
        value: constants.LICENSE_PLAN_LITE,
        displayName: this.getMessageText(i18n, "item_planType_light"),
      },
      {
        value: constants.LICENSE_PLAN_STANDARD,
        displayName: this.getMessageText(i18n, "item_planType_standard"),
      },
      {
        value: constants.LICENSE_PLAN_ENTERPRISE,
        displayName: this.getMessageText(i18n, "item_planType_enterprise"),
      },
      {
        value: constants.LICENSE_PLAN_TALK_LITE,
        displayName: this.getMessageText(i18n, "item_planType_talk_lite"),
      },
      {
        value: constants.LICENSE_PLAN_TALK_ENT,
        displayName: this.getMessageText(i18n, "item_planType_talk_enterprise"),
      },
      {
        value: constants.LICENSE_PLAN_LIVE_LITE,
        displayName: this.getMessageText(i18n, "item_planType_livecast_lite"),
      },
      {
        value: constants.LICENSE_PLAN_LIVE_ENT,
        displayName: this.getMessageText(i18n, "item_planType_livecast_enterprise"),
      },
    ];
  },
  getUpgradePlanType(currentPlanType, newPlanType) {
    switch (currentPlanType) {
      case constants.LICENSE_PLAN_TALK_LITE:
        switch (newPlanType) {
          case constants.LICENSE_PLAN_TALK_ENT:
            return constants.PLAN_UPGRADE_TL_TE;
          case constants.LICENSE_PLAN_LIVE_LITE:
            return constants.PLAN_UPGRADE_TL_LL;
          case constants.LICENSE_PLAN_LIVE_ENT:
            return constants.PLAN_UPGRADE_TL_LE;
          default:
            return -1;
        }
      case constants.LICENSE_PLAN_TALK_ENT:
        switch (newPlanType) {
          case constants.LICENSE_PLAN_TALK_LITE:
            return -1;
          case constants.LICENSE_PLAN_LIVE_LITE:
            return -1;
          case constants.LICENSE_PLAN_LIVE_ENT:
            return constants.PLAN_UPGRADE_TE_LE;
          default:
            return -1;
        }
      case constants.LICENSE_PLAN_LIVE_LITE:
        switch (newPlanType) {
          case constants.LICENSE_PLAN_TALK_LITE:
            return -1;
          case constants.LICENSE_PLAN_TALK_ENT:
            return -1;
          case constants.LICENSE_PLAN_LIVE_ENT:
            return constants.PLAN_UPGRADE_LL_LE;
          default:
            return -1;
        }
      case constants.LICENSE_PLAN_LIVE_ENT:
        return -1;
    }
  },
  getGraceUnitList() {
    return [
      { value: constants.GRACE_UNIT_DAY, displayName: "日単位" },
      { value: constants.GRACE_UNIT_MONTH, displayName: "月単位" },
    ];
  },
  getCurrencyList() {
    return [
      { value: constants.CURRENCY_YEN, displayName: "JPY" },
      { value: constants.CURRENCY_DOLLER, displayName: "USD" },
    ];
  },
  getPriceCategoryList() {
    return [
      { value: 1, displayName: "月契約単価" },
      { value: 2, displayName: "年契約単価" },
      { value: 3, displayName: "従量単価" },
    ];
  },
  getDeferredCommandName(command) {
    switch (command) {
      case constants.DEFERRED_MONTH_TO_YEAR:
        return "月契約－＞年契約に変更";
      case constants.DEFERRED_YEAR_TO_MONTH:
        return "年契約－＞月契約に変更";
      case constants.DEFERRED_TRIAL_TO_ACTIVE_MONTH:
        return "トライアル－＞月契約（自動更新あり）に変更";
      case constants.DEFERRED_TRIAL_TO_ACTIVE_YEAR:
        return "トライアル－＞年契約（自動更新あり）に変更";
      case constants.DEFERRED_TRIAL_TO_NOUPDATE_MONTH:
        return "トライアル－＞月契約（自動更新なし）に変更";
      case constants.DEFERRED_TRIAL_TO_NOUPDATE_YEAR:
        return "トライアル－＞年契約（自動更新なし）に変更";
      case constants.DEFERRED_CHANGE_PRICE:
        return "価格の変更";
      case constants.DEFERRED_CHANGE_PURCHASE_TERM:
        return "契約月数の変更";
      case constants.DEFERRED_DOWNGRADE_TE_TO_TL:
        return "TE－＞TLへのダウングレード";
      case constants.DEFERRED_DOWNGRADE_TE_TO_LL:
        return "TE－＞LLへのダウングレード";
      case constants.DEFERRED_DOWNGRADE_LL_TO_TL:
        return "LL－＞TLへのダウングレード";
      case constants.DEFERRED_DOWNGRADE_LL_TO_TE:
        return "LL－＞TEへのダウングレード";
      case constants.DEFERRED_DOWNGRADE_LE_TO_LL:
        return "LE－＞LLへのダウングレード";
      case constants.DEFERRED_DOWNGRADE_LE_TO_TE:
        return "LE－＞TEへのダウングレード";
      case constants.DEFERRED_DOWNGRADE_LE_TO_TL:
        return "LE－＞TLへのダウングレード";
      case constants.DEFERRED_UPGRADE_TL_TO_TE:
        return "TL－＞TEへのアップグレード";
      case constants.DEFERRED_UPGRADE_TL_TO_LL:
        return "TL－＞LLへのアップグレード";
      case constants.DEFERRED_UPGRADE_TL_TO_LE:
        return "TL－＞LEへのアップグレード";
      case constants.DEFERRED_UPGRADE_TE_TO_LE:
        return "TE－＞LEへのアップグレード";
      case constants.DEFERRED_UPGRADE_LL_TO_LE:
        return "LL－＞LEへのアップグレード";
      default:
        return "";
    }
  },
  getContractChangeNotice(i18n, basicContract) {
    let nextFlushDatetime = this.getDisplayExpireDateTime(basicContract);
    let from = this.getPurchasePeriodTypeName(i18n, basicContract.purchasePeriodType);
    let to;
    switch (basicContract.purchasePeriodType) {
      case constants.PURCHASE_PERIOD_MONTHLY:
        to = this.getPurchasePeriodTypeName(i18n, constants.PURCHASE_PERIOD_YEARLY);
        break;
      case constants.PURCHASE_PERIOD_YEARLY:
        to = this.getPurchasePeriodTypeName(i18n, constants.PURCHASE_PERIOD_MONTHLY);
        break;
    }
    return this.getMessageText(i18n, "info_change_contract_notice")
      .replace("{contractDate}", nextFlushDatetime)
      .replace("{from}", from)
      .replace("{to}", to);
  },
  getPlanChangeNotice(i18n, basicContract, newPlan, upgrade) {
    let nextFlushDatetime = this.getDisplayExpireDateTime(basicContract);
    let from = this.getPlanName(basicContract.planType);
    let to = this.getPlanName(newPlan);
    if (upgrade) {
      return this.getMessageText(i18n, "info_plan_upgrade_notice").replace("{planName}", to);
    } else {
      return this.getMessageText(i18n, "info_change_contract_notice")
        .replace("{contractDate}", nextFlushDatetime)
        .replace("{from}", from)
        .replace("{to}", to);
    }
  },
  getDisplayExpireDateTime(basicContract) {
    if (basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
      return new Date(basicContract.startDatetime).toLocaleString();
    } else {
      return new Date(basicContract.nextFlushDatetime).toLocaleString();
    }
  },
  getDisplayPrice(currencyYen, price) {
    if (currencyYen) {
      return Number(price).toLocaleString();
    } else {
      return Number(price).toFixed(2).toLocaleString();
    }
  },
  getDeferredProcessContractList(purchasePeriodType) {
    let deferredProcessContractList = [];
    switch (purchasePeriodType) {
      case constants.PURCHASE_PERIOD_MONTHLY:
        deferredProcessContractList.push({
          displayName: this.getDeferredCommandName(constants.DEFERRED_MONTH_TO_YEAR),
          deferredRequestType: constants.DEFERRED_MONTH_TO_YEAR,
        });
        break;
      case constants.PURCHASE_PERIOD_YEARLY:
        deferredProcessContractList.push({
          displayName: this.getDeferredCommandName(constants.DEFERRED_YEAR_TO_MONTH),
          deferredRequestType: constants.DEFERRED_YEAR_TO_MONTH,
        });
        break;
      case constants.PURCHASE_PERIOD_TRIAL:
        deferredProcessContractList.push({
          displayName: this.getDeferredCommandName(constants.DEFERRED_TRIAL_TO_ACTIVE_MONTH),
          deferredRequestType: constants.DEFERRED_TRIAL_TO_ACTIVE_MONTH,
        });
        deferredProcessContractList.push({
          displayName: this.getDeferredCommandName(constants.DEFERRED_TRIAL_TO_ACTIVE_YEAR),
          deferredRequestType: constants.DEFERRED_TRIAL_TO_ACTIVE_YEAR,
        });
        deferredProcessContractList.push({
          displayName: this.getDeferredCommandName(constants.DEFERRED_TRIAL_TO_NOUPDATE_MONTH),
          deferredRequestType: constants.DEFERRED_TRIAL_TO_NOUPDATE_MONTH,
        });
        deferredProcessContractList.push({
          displayName: this.getDeferredCommandName(constants.DEFERRED_TRIAL_TO_NOUPDATE_YEAR),
          deferredRequestType: constants.DEFERRED_TRIAL_TO_NOUPDATE_YEAR,
        });
        break;
    }
    return deferredProcessContractList;
  },
  getBillingTypeList() {
    return [
      { value: constants.BILLING_UNDEFINED, displayName: "未定" },
      { value: constants.BILLING_CREDIT_CARD, displayName: "クレジットカード" },
      { value: constants.BILLING_PAPER, displayName: "請求書" },
      { value: constants.BILLING_PAID, displayName: "PAID決済" },
      { value: constants.BILLING_TRANSFER, displayName: "振り込み" },
    ];
  },
  isOnlinePurchase(billingType) {
    return (
      billingType === constants.BILLING_UNDEFINED ||
      billingType === constants.BILLING_CREDIT_CARD ||
      billingType === constants.BILLING_PAID ||
      billingType === constants.BILLING_TRANSFER
    );
  },
  isPaidOrderId(orderId) {
    return (
      orderId.indexOf(constants.ORDER_ID_PREFIX_PAID) === 0 ||
      // メンテナンスサーバーのorderIdの採番が下記フォーマットだったため、判定を追加
      orderId.indexOf(constants.ORDER_ID_PREFIX_NEW_PAID) === 0 ||
      orderId.indexOf(constants.ORDER_ID_PREFIX_CONTINUE_PAID) === 0 ||
      orderId.indexOf(constants.ORDER_ID_PREFIX_UPDATE_PAID) === 0 ||
      orderId.indexOf(constants.ORDER_ID_PREFIX_NEW_PAID_TEST) === 0 ||
      orderId.indexOf(constants.ORDER_ID_PREFIX_CONTINUE_PAID_TEST) === 0 ||
      orderId.indexOf(constants.ORDER_ID_PREFIX_UPDATE_PAID_TEST) === 0
    );
  },
  getBillableRate(nextFlushDatetime) {
    let flushDate = new Date(nextFlushDatetime);
    let remainingDate = Math.floor((flushDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24)) + 1;
    let startDate = new Date(nextFlushDatetime);
    startDate.setYear(startDate.getYear() + 1900 - 1);
    let dayOfYear = Math.floor((flushDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
    return remainingDate / dayOfYear;
  },
  getDowngradeDeferredRequestCode(currentPlan, newPlan) {
    switch (currentPlan) {
      case constants.LICENSE_PLAN_TALK_ENT:
        switch (newPlan) {
          case constants.LICENSE_PLAN_TALK_LITE:
            return constants.DEFERRED_DOWNGRADE_TE_TO_TL;
          case constants.LICENSE_PLAN_LIVE_LITE:
            return constants.DEFERRED_DOWNGRADE_TE_TO_LL;
          default:
            return -1;
        }
      case constants.LICENSE_PLAN_LIVE_LITE:
        switch (newPlan) {
          case constants.LICENSE_PLAN_TALK_LITE:
            return constants.DEFERRED_DOWNGRADE_LL_TO_TL;
          case constants.LICENSE_PLAN_TALK_ENT:
            return constants.DEFERRED_DOWNGRADE_LL_TO_TE;
          default:
            return -1;
        }
      case constants.LICENSE_PLAN_LIVE_ENT:
        switch (newPlan) {
          case constants.LICENSE_PLAN_TALK_LITE:
            return constants.DEFERRED_DOWNGRADE_LE_TO_TL;
          case constants.LICENSE_PLAN_TALK_ENT:
            return constants.DEFERRED_DOWNGRADE_LE_TO_TE;
          case constants.LICENSE_PLAN_LIVE_LITE:
            return constants.DEFERRED_DOWNGRADE_LE_TO_LL;
          default:
            return -1;
        }
      default:
        return -1;
    }
  },
  getOnOffMode(i18n, mode) {
    switch (Number(mode)) {
      case constants.STATUS_MODE_OFF:
        return this.getMessageText(i18n, "value_off");
      case constants.STATUS_MODE_ON:
        return this.getMessageText(i18n, "value_on");
    }
  },
  getVibrationList(i18n) {
    let vibeTypeListText = this.getMessageText(i18n, "item_client_vibrate_type_list").split(",");
    let vibeTypeList = [];
    let i = 0;
    for (let i = 0; i < 4; i++) {
      vibeTypeList.push({ value: i, label: vibeTypeListText[i] });
    }
    return vibeTypeList;
  },
  getVibrationType(i18n, type) {
    switch (type) {
      case 0:
      case 1:
      case 2:
      case 3:
        return this.getMessageText(i18n, "item_client_vibrate_type").replace("{No}", type + 1);
      default:
        return undefined;
    }
  },
  isReserveTalkEnabled(apps) {
    return apps != null && (apps & constants.RESERVE_TALK) !== 0;
  },
  isSummaryHistoryEnabled(apps) {
    return apps != null && (apps & constants.RESERVED3) !== 0;
  },
  getSubButtonModeList(i18n, enableSafetySupport, tenantApps) {
    const baseActions = [
      {
        value: constants.SUB_BUTTON_NONE,
        label: this.getMessageText(i18n, "item_client_subButton0"),
      },
      { value: constants.SUB_BUTTON_NFC, label: "NFC" },
      {
        value: constants.SUB_BUTTON_CUSTOMURL,
        label: this.getMessageText(i18n, "item_client_subButton2"),
      },
      {
        value: constants.SUB_BUTTON_VOX,
        label: this.getMessageText(i18n, "item_client_subButton3"),
      },
      {
        value: constants.SUB_BUTTON_FTT,
        label: this.getMessageText(i18n, "item_client_subButton4"),
      },
      {
        value: constants.SUB_BUTTON_Secondary,
        label: this.getMessageText(i18n, "item_client_subButton5"),
      },
      {
        value: constants.SUB_BUTTON_Voice_Report,
        label: this.getMessageText(i18n, "item_client_subButton13"),
      },
      {
        value: constants.SUB_BUTTON_LOCK,
        label: this.getMessageText(i18n, "item_client_subButton6"),
      },
      {
        value: constants.SUB_BUTTON_METADATA,
        label: this.getMessageText(i18n, "item_client_subButton7"),
      },
      {
        value: constants.SUB_BUTTON_FixedPhrase,
        label: this.getMessageText(i18n, "item_client_subButton8"),
      },
    ];

    if (FEATURE_BD_2018_RESERVE_TALK_CLIENT_SETTINGS && this.isReserveTalkEnabled(tenantApps)) {
      baseActions.push({
        value: constants.SUB_BUTTON_Reserve_Talk,
        label: this.getMessageText(i18n, "item_client_subButton14"),
      });
    }

    return baseActions.filter(
      (action) => enableSafetySupport || action.value !== constants.SUB_BUTTON_Voice_Report
    );
  },
  getServerButtonBindActionList(i18n, tenantApps, enableSafetySupport) {
    // 6については、Android用にてACTION_CUSTOM_ASSISTANTを利用しており、一括設定の対象外。
    const staticButtonAction = [
      { value: 0, label: this.getMessageText(i18n, "item_client_button_msg0") },
      { value: 1, label: this.getMessageText(i18n, "item_client_button_msg1") },
      { value: 2, label: this.getMessageText(i18n, "item_client_button_msg2") },
      { value: 3, label: this.getMessageText(i18n, "item_client_button_msg3") },
      { value: 9, label: this.getMessageText(i18n, "item_client_button_msg9") },
      { value: 4, label: this.getMessageText(i18n, "item_client_button_msg4") },
      { value: 5, label: this.getMessageText(i18n, "item_client_button_msg5") },
      { value: 6, label: this.getMessageText(i18n, "item_client_button_msg6") },
      { value: 7, label: this.getMessageText(i18n, "item_client_button_msg7") },
      { value: 8, label: this.getMessageText(i18n, "item_client_button_msg8") },
    ].filter((action) => {
      const isChatGptAction = action.value === 5 || action.value === 6;
      const isSafetySupportAction = action.value === 9;

      if (isChatGptAction && (tenantApps & constants.CHAT_GPT) === 0) {
        return false;
      }
      if (isSafetySupportAction && !enableSafetySupport) {
        return false;
      }
      return true;
    });

    if (FEATURE_BD_2018_RESERVE_TALK_CLIENT_SETTINGS && this.isReserveTalkEnabled(tenantApps)) {
      // セカンドグループ発信の次に表示させる
      const secondaryTalkActionIndex = staticButtonAction.findIndex((action) => action.value === 3);
      staticButtonAction.splice(
        secondaryTalkActionIndex + 1,
        0,
        { value: 10, label: this.getMessageText(i18n, "item_client_button_msg10") },
        { value: 11, label: this.getMessageText(i18n, "item_client_button_msg11") }
      );
    }

    const dynamicButtonAction = Array.from({ length: 20 }, (_, i) => ({
      value: i + 100,
      label: this.getMessageArgsText(i18n, `item_client_button_fixPhrase`, { number: i + 1 }),
    }));
    return [...staticButtonAction, ...dynamicButtonAction];
  },
  getPreferredNetworkAndroidList(i18n) {
    return [
      { value: 0, label: this.getMessageText(i18n, "item_client_preferred_network_android_wifi") },
      {
        value: 1,
        label: this.getMessageText(i18n, "item_client_preferred_network_android_mobile"),
      },
    ];
  },
  getPreferredNetworkIOSList(i18n) {
    return [
      { value: 0, label: this.getMessageText(i18n, "item_client_preferred_network_ios_wifi") },
      { value: 1, label: this.getMessageText(i18n, "item_client_preferred_network_ios_mobile") },
      {
        value: 2,
        label: this.getMessageText(i18n, "item_client_preferred_network_ios_wifi_with_mobile"),
      },
    ];
  },
  getSubButtonMode(i18n, type) {
    switch (type) {
      case 0:
        return this.getMessageText(i18n, "item_client_subButton0");
      case 1:
        return "NFC";
      case 2:
        return this.getMessageText(i18n, "item_client_subButton0");
      default:
        return undefined;
    }
  },
  getLocationIntervalModeList(i18n) {
    let interval = [5, 30, 60, 300];
    let intervalListText = this.getMessageText(i18n, "item_client_location_interval_list").split(
      ","
    );
    let intervalList = [];
    let i = 0;
    for (let intervalValue of interval) {
      intervalList.push({ value: intervalValue, label: intervalListText[i] });
      i++;
    }
    return intervalList;
  },
  getCutVoiceDelayQueueSecondsList(i18n) {
    let disabledLabel = this.getMessageText(i18n, "item_client_cut_voice_delay_disabled");
    let suffix = this.getMessageText(i18n, "item_client_cut_voice_delay_seconds_suffix");
    let list = [{ value: constants.CUT_VOICE_DELAY_QUEUE_SECONDS_DISABLED, label: disabledLabel }];
    for (
      let i = constants.CUT_VOICE_DELAY_QUEUE_SECONDS_MIN;
      i <= constants.CUT_VOICE_DELAY_QUEUE_SECONDS_MAX;
      i++
    ) {
      list.push({ value: i, label: i + suffix });
    }
    return list;
  },
  getLocationIntervalMode(i18n, type) {
    switch (type) {
      case 5:
      case 30:
      case 60:
      case 300:
        return this.getMessageText(i18n, "item_client_second").replace("{time}", type);
      default:
        return undefined;
    }
  },
  getLanguageIndexList(currentLocale) {
    const languageList = [
      {
        value: 1,
        description: "日本語",
        description_en: "Japanese",
        countryCode: ["JPN"],
        languageCode: "ja-JP",
      },
      {
        value: 2,
        description: "英語",
        description_en: "English",
        countryCode: ["USA"],
        languageCode: "en-US",
      },
      {
        value: 3,
        description: "中国語（簡体字）",
        description_en: "Simplified Chinese",
        countryCode: ["CHN"],
        languageCode: "zh-CN",
      },
      {
        value: 18,
        description: "中国語（繁体字）",
        description_en: "Traditional Chinese",
        countryCode: ["TWN"],
        languageCode: "zh-TW",
      },
      {
        value: 4,
        description: "ベトナム語",
        description_en: "Vietnamese",
        countryCode: ["VNM"],
        languageCode: "vi-VN",
      },
      {
        value: 5,
        description: "タイ語",
        description_en: "Thai",
        countryCode: ["THA"],
        languageCode: "th-TH",
      },
      {
        value: 6,
        description: "ドイツ語",
        description_en: "German",
        countryCode: ["DEU"],
        languageCode: "de-DE",
      },
      {
        value: 7,
        description: "フランス語",
        description_en: "French",
        countryCode: ["FRA"],
        languageCode: "fr-FR",
      },
      {
        value: 8,
        description: "スペイン語",
        description_en: "Spanish",
        countryCode: ["ESP"],
        languageCode: "es-ES",
      },
      {
        value: 9,
        description: "イタリア語",
        description_en: "Italian",
        countryCode: ["ITA"],
        languageCode: "it-IT",
      },
      {
        value: 10,
        description: "ポルトガル語(ポルトガル)",
        description_en: "Portuguese（Portugal）",
        countryCode: ["PRT"],
        languageCode: "pt-PT",
      },
      {
        value: 11,
        description: "ロシア語",
        description_en: "Russian",
        countryCode: ["RUS"],
        languageCode: "ru-RU",
      },
      {
        value: 12,
        description: "韓国語",
        description_en: "Korean",
        countryCode: ["KOR"],
        languageCode: "ko-KR",
      },
      {
        value: 13,
        description: "インドネシア語",
        description_en: "Indonesian",
        countryCode: ["IDN"],
        languageCode: "id-ID",
      },
      {
        value: 14,
        description: "フィンランド語",
        description_en: "Finnish",
        countryCode: ["FIN"],
        languageCode: "fi-FI",
      },
      {
        value: 15,
        description: "オランダ語",
        description_en: "Dutch",
        countryCode: ["NLD"],
        languageCode: "nl-NL",
      },
      {
        value: 16,
        description: "ポーランド語",
        description_en: "Polish",
        countryCode: ["POL"],
        languageCode: "pl-PL",
      },
      {
        value: 17,
        description: "ウクライナ語",
        description_en: "Ukrainian",
        countryCode: ["UKR"],
        languageCode: "uk-UA",
      },
      {
        value: 19,
        description: "ヒンディー語",
        description_en: "Hindi",
        countryCode: ["HIN"],
        languageCode: "hi-IN",
      },
      {
        value: 20,
        description: "ネパール語",
        description_en: "Nepali",
        countryCode: ["NEP"],
        languageCode: "ne-NP",
      },
      {
        value: 21,
        description: "シンハラ語",
        description_en: "Sinhalese",
        countryCode: ["SIN"],
        languageCode: "si-LK",
      },
      {
        value: 22,
        description: "ベンガル語",
        description_en: "Bengali",
        countryCode: ["BEN"],
        languageCode: "bn-BD",
      },
      {
        value: 23,
        description: "クメール語",
        description_en: "Khmer",
        countryCode: ["KHM"],
        languageCode: "km-KH",
      },
      {
        value: 24,
        description: "アイスランド語",
        description_en: "Icelandic",
        countryCode: ["ISL"],
        languageCode: "is-IS",
      },
      {
        value: 25,
        description: "アイルランド語",
        description_en: "Irish",
        countryCode: ["GLE"],
        languageCode: "ga-IE",
      },
      {
        value: 26,
        description: "アゼルバイジャン語",
        description_en: "Azerbaijani",
        countryCode: ["AZE"],
        languageCode: "az-AZ",
      },
      {
        value: 27,
        description: "アッサム語",
        description_en: "Assamese",
        countryCode: ["ASM"],
        languageCode: "as-IN",
      },
      {
        value: 28,
        description: "アフリカーンス語",
        description_en: "Afrikaans",
        countryCode: ["AFR"],
        languageCode: "af-ZA",
      },
      {
        value: 29,
        description: "アムハラ語",
        description_en: "Amharic",
        countryCode: ["AMH"],
        languageCode: "am-ET",
      },
      {
        value: 30,
        description: "アラビア語",
        description_en: "Arabic",
        countryCode: ["ARA"],
        languageCode: "ar-SA",
      },
      {
        value: 31,
        description: "アルバニア語",
        description_en: "Albanian",
        countryCode: ["ALB"],
        languageCode: "sq-AL",
      },
      {
        value: 32,
        description: "アルメニア語",
        description_en: "Armenian",
        countryCode: ["HYE"],
        languageCode: "hy-AM",
      },
      {
        value: 33,
        description: "ウェールズ語",
        description_en: "Welsh",
        countryCode: ["CYM"],
        languageCode: "cy-GB",
      },
      {
        value: 34,
        description: "ウズベク語",
        description_en: "Uzbek",
        countryCode: ["UZB"],
        languageCode: "uz-UZ",
      },
      {
        value: 35,
        description: "ウルドゥー語",
        description_en: "Urdu",
        countryCode: ["URD"],
        languageCode: "ur-IN",
      },
      {
        value: 36,
        description: "エストニア語",
        description_en: "Estonian",
        countryCode: ["EST"],
        languageCode: "et-EE",
      },
      {
        value: 37,
        description: "オディア語",
        description_en: "Odia",
        countryCode: ["ORI"],
        languageCode: "or-IN",
      },
      {
        value: 38,
        description: "カザフ語",
        description_en: "Kazakh",
        countryCode: ["KAZ"],
        languageCode: "kk-KZ",
      },
      {
        value: 39,
        description: "カタルーニャ語",
        description_en: "Catalan",
        countryCode: ["CAT"],
        languageCode: "ca-ES",
      },
      {
        value: 40,
        description: "ガリシア語",
        description_en: "Galician",
        countryCode: ["GLG"],
        languageCode: "gl-ES",
      },
      {
        value: 41,
        description: "カンナダ語",
        description_en: "Kannada",
        countryCode: ["KAN"],
        languageCode: "kn-IN",
      },
      {
        value: 42,
        description: "キニヤルワンダ語",
        description_en: "Kinyarwanda",
        countryCode: ["KIN"],
        languageCode: "rw-RW",
      },
      {
        value: 43,
        description: "ギリシャ語",
        description_en: "Greek",
        countryCode: ["GRE"],
        languageCode: "el-GR",
      },
      {
        value: 44,
        description: "グジャラート語",
        description_en: "Gujarati",
        countryCode: ["GUJ"],
        languageCode: "gu-IN",
      },
      {
        value: 45,
        description: "クロアチア語",
        description_en: "Croatian",
        countryCode: ["HRV"],
        languageCode: "hr-HR",
      },
      {
        value: 46,
        description: "ジャワ語",
        description_en: "Javanese",
        countryCode: ["JAV"],
        languageCode: "jv-ID",
      },
      {
        value: 47,
        description: "ジョージア語",
        description_en: "Georgian",
        countryCode: ["KAT"],
        languageCode: "ka-GE",
      },
      {
        value: 48,
        description: "スウェーデン語",
        description_en: "Swedish",
        countryCode: ["SWE"],
        languageCode: "sv-SE",
      },
      {
        value: 49,
        description: "ズールー語",
        description_en: "Zulu",
        countryCode: ["ZUL"],
        languageCode: "zu-ZA",
      },
      {
        value: 50,
        description: "スロバキア語",
        description_en: "Slovak",
        countryCode: ["SLK"],
        languageCode: "sk-SK",
      },
      {
        value: 51,
        description: "スロベニア語",
        description_en: "Slovenian",
        countryCode: ["SLV"],
        languageCode: "sl-SI",
      },
      {
        value: 52,
        description: "スワヒリ語",
        description_en: "Swahili",
        countryCode: ["SWA"],
        languageCode: "sw-TZ",
      },
      {
        value: 53,
        description: "スンダ語",
        description_en: "Sundanese",
        countryCode: ["SUN"],
        languageCode: "su-ID",
      },
      {
        value: 54,
        description: "ツワナ語",
        description_en: "Tswana",
        countryCode: ["TSN"],
        languageCode: "tn-Latn-ZA",
      },
      {
        value: 55,
        description: "セルビア語",
        description_en: "Serbian",
        countryCode: ["SRP"],
        languageCode: "sr-RS",
      },
      {
        value: 56,
        description: "ソマリ語",
        description_en: "Somali",
        countryCode: ["SOM"],
        languageCode: "so-SO",
      },
      {
        value: 57,
        description: "タガログ語",
        description_en: "Tagalog (Filipino)",
        countryCode: ["TGL"],
        languageCode: "fil-PH",
      },
      {
        value: 58,
        description: "タミル語",
        description_en: "Tamil",
        countryCode: ["TAM"],
        languageCode: "ta-IN",
      },
      {
        value: 59,
        description: "チェコ語",
        description_en: "Czech",
        countryCode: ["CES"],
        languageCode: "cs-CZ",
      },
      {
        value: 60,
        description: "テルグ語",
        description_en: "Telugu",
        countryCode: ["TEL"],
        languageCode: "te-IN",
      },
      {
        value: 61,
        description: "デンマーク語",
        description_en: "Danish",
        countryCode: ["DAN"],
        languageCode: "da-DK",
      },
      {
        value: 62,
        description: "トルコ語",
        description_en: "Turkish",
        countryCode: ["TUR"],
        languageCode: "tr-TR",
      },
      {
        value: 63,
        description: "ノルウェー語(ブークモール)",
        description_en: "Norwegian (Bokmål)",
        countryCode: ["NOR"],
        languageCode: "nb-NO",
      },
      {
        value: 64,
        description: "パシュトゥー語",
        description_en: "Pashto",
        countryCode: ["PAS"],
        languageCode: "ps-AF",
      },
      {
        value: 65,
        description: "バスク語",
        description_en: "Basque",
        countryCode: ["EUS"],
        languageCode: "eu-ES",
      },
      {
        value: 66,
        description: "ハンガリー語",
        description_en: "Hungarian",
        countryCode: ["HUN"],
        languageCode: "hu-HU",
      },
      {
        value: 67,
        description: "パンジャブ語",
        description_en: "Punjabi",
        countryCode: ["PAN"],
        languageCode: "pa-IN",
      },
      {
        value: 68,
        description: "ブルガリア語",
        description_en: "Bulgarian",
        countryCode: ["BUL"],
        languageCode: "bg-BG",
      },
      {
        value: 69,
        description: "ヘブライ語",
        description_en: "Hebrew",
        countryCode: ["HEB"],
        languageCode: "he-IL",
      },
      {
        value: 70,
        description: "ペルシャ語",
        description_en: "Persian",
        countryCode: ["PER"],
        languageCode: "fa-IR",
      },
      {
        value: 71,
        description: "ボスニア語",
        description_en: "Bosnian",
        countryCode: ["BOS"],
        languageCode: "bs-BA",
      },
      {
        value: 72,
        description: "マケドニア語",
        description_en: "Macedonian",
        countryCode: ["MKD"],
        languageCode: "mk-MK",
      },
      {
        value: 73,
        description: "マラーティー語",
        description_en: "Marathi",
        countryCode: ["MAR"],
        languageCode: "mr-IN",
      },
      {
        value: 74,
        description: "マラヤーラム語",
        description_en: "Malayalam",
        countryCode: ["MAL"],
        languageCode: "ml-IN",
      },
      {
        value: 75,
        description: "マルタ語",
        description_en: "Maltese",
        countryCode: ["MLT"],
        languageCode: "mt-MT",
      },
      {
        value: 76,
        description: "マレー語",
        description_en: "Malay",
        countryCode: ["MAY"],
        languageCode: "ms-MY",
      },
      {
        value: 77,
        description: "ミャンマー語",
        description_en: "Myanmar (Burmese)",
        countryCode: ["MYA"],
        languageCode: "my-MM",
      },
      {
        value: 78,
        description: "モンゴル語",
        description_en: "Mongolian",
        countryCode: ["MON"],
        languageCode: "mn-MN",
      },
      {
        value: 79,
        description: "ラオ語",
        description_en: "Lao",
        countryCode: ["LAO"],
        languageCode: "lo-LA",
      },
      {
        value: 80,
        description: "ラトビア語",
        description_en: "Latvian",
        countryCode: ["LAV"],
        languageCode: "lv-LV",
      },
      {
        value: 81,
        description: "リトアニア語",
        description_en: "Lithuanian",
        countryCode: ["LIT"],
        languageCode: "lt-LT",
      },
      {
        value: 82,
        description: "ルーマニア語",
        description_en: "Romanian",
        countryCode: ["RON"],
        languageCode: "ro-RO",
      },
      {
        value: 83,
        description: "広東語(香港)",
        description_en: "Cantonese (Hong Kong)",
        countryCode: ["YUE"],
        languageCode: "yue-CN",
      },
      {
        value: 84,
        description: "南部ソト語",
        description_en: "Southern Sotho",
        countryCode: ["SOT"],
        languageCode: "st-ZA",
      },
      {
        value: 85,
        description: "ポルトガル語 (ブラジル)",
        description_en: "Portuguese（Brazil）",
        countryCode: ["POB"],
        languageCode: "pt-BR",
      },
    ];
    let sortedLanguages;
    if (currentLocale.startsWith("ja")) {
      sortedLanguages = languageList.sort((a, b) =>
        a.description.localeCompare(b.description, "ja-JP")
      );
    } else {
      sortedLanguages = languageList.sort((a, b) =>
        a.description_en.localeCompare(b.description_en, "en-US")
      );
    }
    return sortedLanguages;
  },
  getSettingDefinition() {
    return {
      commonSetting: {
        description: "共通設定",
        autoStart: {
          default: 1,
          description: "OS起動時の自動実行",
          values: [
            { value: 0, description: "オフ" },
            { value: 1, description: "オン" },
          ],
        },
        mainButtonMode: {
          default: 0,
          description: "メインボタンの動作",
          values: [
            { value: 0, description: "ホールド" },
            { value: 1, description: "トグル" },
          ],
        },
        subButtonMode: {
          default: 0,
          description: "サブボタンの動作",
          values: [
            { value: 0, description: "なし" },
            { value: 1, description: "NFC" },
          ],
        },
      },
      talkSetting: { description: "トーク設定" },
      volumeSetting: {
        description: "サウンドボリューム設定",
        reconnectSound: {
          default: 1,
        },
        reconnectSoundVolume: {
          default: 100,
          description: "再接続時のアラート音",
        },
        reactionSound: {
          default: 1,
        },
        reactionSoundVolume: {
          default: 100,
          description: "操作音",
        },
        receiveBeep: {
          default: 0,
        },
        receiveBeepVolume: {
          default: 100,
          description: "受信時のビープ音",
        },
        voice: {
          default: 1,
        },
        voiceVolume: {
          default: 100,
          description: "音声",
        },
        voiceOffHook: {
          default: 0,
        },
        voiceOffHookVolume: {
          default: 100,
          description: "通話中の音声",
        },
        micVolume: {
          default: 100,
          description: "マイク",
        },
      },
      chatSetting: {
        description: "チャット設定",
        autoSpeak: {
          default: 1,
          description: "翻訳時の自動読み上げ",
          values: [
            { value: 0, description: "オフ" },
            { value: 1, description: "オン" },
          ],
        },
      },
      languageSetting: {
        default: 1,
        description: "言語",
        values: [
          { value: 1, description: "日本語" },
          { value: 2, description: "英語" },
          { value: 3, description: "中国語（簡体字）" },
          { value: 18, description: "中国語（繁体字）" },
          { value: 4, description: "ベトナム語" },
          { value: 5, description: "タイ語" },
          { value: 6, description: "ドイツ語" },
          { value: 7, description: "フランス語" },
          { value: 8, description: "スペイン語" },
          { value: 9, description: "イタリア語" },
          { value: 10, description: "ポルトガル語" },
          { value: 11, description: "ロシア語" },
          { value: 12, description: "韓国語" },
          { value: 13, description: "インドネシア語" },
          { value: 14, description: "フィンランド語" },
          { value: 15, description: "オランダ語" },
          { value: 16, description: "ポーランド語" },
          { value: 17, description: "ウクライナ語" },
          { value: 19, description: "ヒンディー語" },
          { value: 20, description: "ネパール語" },
          { value: 21, description: "シンハラ語" },
          { value: 22, description: "ベンガル語" },
          { value: 23, description: "クメール語" },
          { value: 24, description: "モンゴル語" },
        ],
      },
      notificationSetting: {
        description: "通知設定",
        onNewTalker: {
          default: 0,
          description: "音声受信時",
          values: [
            { value: 0, description: "オフ" },
            { value: 1, description: "オン" },
          ],
        },
        vibeOnNewTalker: {
          default: 0,
          description: "音声受信時の振動",
          values: [
            { value: 0, description: "オフ" },
            { value: 1, description: "オン" },
          ],
        },
        onNewMessage: {
          default: 0,
          description: "メッセージ受信時",
          values: [
            { value: 0, description: "オフ" },
            { value: 1, description: "オン" },
          ],
        },
        vibeOnNewMessage: {
          default: 0,
          description: "メッセージ受信時の振動",
          values: [
            { value: 0, description: "オフ" },
            { value: 1, description: "オン" },
          ],
        },
      },
    };
  },
  getAWSRegionName(region) {
    switch (region) {
      case "aws:us-east-1":
        return "Virginia";
      case "aws:us-east-2":
        return "Ohio";
      case "aws:us-west-1":
        return "California";
      case "aws:us-west-2":
        return "Oregon";
      case "aws:ca-central-1":
        return "Canada";
      case "aws:eu-central-1":
        return "Frankfurt";
      case "aws:eu-west-1":
        return "Ireland";
      case "aws:eu-west-2":
        return "London";
      case "aws:eu-west-3":
        return "Paris";
      case "aws:ap-northeast-1":
        return "Tokyo";
      case "aws:ap-northeast-2":
        return "Seoul";
      case "aws:ap-northeast-3":
        return "Osaka";
      case "aws:ap-southeast-1":
        return "Singapore";
      case "aws:ap-southeast-2":
        return "Sydney";
      case "aws:ap-south-1":
        return "Mumbai";
      case "aws:sa-east-1":
        return "SaoPaulo";
      default:
        return region;
    }
  },
  getTenantOptionList() {
    return [
      { value: false, displayName: "トークレコードを物理削除" },
      { value: false, displayName: "最大グループ数を100に制限" },
      { value: false, displayName: "IPアドレスを制限する" },
      { value: false, displayName: "AI・App連携トライアルを設定する" },
    ];
  },
  putExceptionErrorMessage(self, functionName, error) {
    if (error.message.indexOf("Network Error") >= 0) {
      this.notifyMessage(self, "Error", this.getMessageText(self.$i18n, "error_network"));
      return;
    }
    if (error.message.indexOf("Server Error") >= 0) {
      let message = this.getMessageText(self.$i18n, "error_server");
      this.notifyMessage(
        self,
        "Error",
        message
          .replace("{functionName}", functionName)
          .replace("{status}", error.message.split("=")[1])
      );
      return;
    }
    if (error.message.indexOf("Timeout Error") >= 0) {
      let message = this.getMessageText(self.$i18n, "error_timeout");
      return;
    }
    let message = this.getMessageText(self.$i18n, "error_system");
    this.notifyMessage(
      self,
      "Error",
      message.replace("{functionName}", functionName).replace("{error}", error)
    );
  },
  getPrefList() {
    return [
      "北海道",
      "青森県",
      "岩手県",
      "宮城県",
      "秋田県",
      "山形県",
      "福島県",
      "茨城県",
      "栃木県",
      "群馬県",
      "埼玉県",
      "千葉県",
      "東京都",
      "神奈川県",
      "新潟県",
      "富山県",
      "石川県",
      "福井県",
      "山梨県",
      "長野県",
      "岐阜県",
      "静岡県",
      "愛知県",
      "三重県",
      "滋賀県",
      "京都府",
      "大阪府",
      "兵庫県",
      "奈良県",
      "和歌山県",
      "鳥取県",
      "島根県",
      "岡山県",
      "広島県",
      "山口県",
      "徳島県",
      "香川県",
      "愛媛県",
      "高知県",
      "福岡県",
      "佐賀県",
      "長崎県",
      "熊本県",
      "大分県",
      "宮崎県",
      "鹿児島県",
      "沖縄県",
    ];
  },
  purchaseLicenseConditionCheck(numberLicenseList, usageLicenseList, chargeLicenseList, i18n) {
    let licenseErrorMessage = "";
    let speechToText = false;
    for (let numberLicense of numberLicenseList) {
      if (numberLicense.newValue > 0) {
        let recurringLicense;
        switch (numberLicense.type) {
          case constants.LICENSE_SPEECH_TEXT:
            speechToText = true;
            let recurringLicense = usageLicenseList.filter(function (value) {
              return value.type === constants.RECURRING_SPEECH_TEXT;
            });
            if (recurringLicense[0].newValue > 0) {
              break;
            }
            if (chargeLicenseList != null) {
              let chargeLicense = chargeLicenseList.filter(function (value) {
                return value.type === constants.CHARGE_SPEECH_TEXT;
              });
              if (chargeLicense[0].newValue > 0) {
                break;
              }
            }
            licenseErrorMessage +=
              this.getMessageText(i18n, "error_recurring_speech_not_found") + "\n";
            break;
          case constants.LICENSE_TRANSLATION:
            if (!speechToText) {
              licenseErrorMessage +=
                this.getMessageText(i18n, "error_need_speech_with_translation") + "\n";
            } else {
              let recurringLicense = usageLicenseList.filter(function (value) {
                return value.type === constants.RECURRING_TRANSLATION;
              });
              if (recurringLicense[0].newValue > 0) {
                break;
              }
              if (chargeLicenseList != null) {
                let chargeLicense = chargeLicenseList.filter(function (value) {
                  return value.type === constants.CHARGE_TRANSLATION;
                });
                if (chargeLicense[0].newValue > 0) {
                  break;
                }
              }
              licenseErrorMessage +=
                this.getMessageText(i18n, "error_recurring_translation_not_found") + "\n";
            }
            break;
        }
      }
    }
    return licenseErrorMessage;
  },
  checkUserPrivilege(rights, privilege) {
    if (rights == null) {
      return false;
    }
    if (rights.split(",").includes(privilege)) {
      return true;
    } else {
      return false;
    }
  },
  convertMillsec(duration) {
    if (!duration) {
      return "00:00.00";
    }

    let minuts = Math.floor(duration / 1000 / 60);
    let seconds = Math.floor((duration % (1000 * 60)) / 1000);
    let millsec = Math.floor((duration % 1000) / 10);
    return (
      (minuts < 10 ? "0" : "") +
      minuts +
      ":" +
      (seconds < 10 ? "0" : "") +
      seconds +
      "." +
      (millsec < 10 ? "0" : "") +
      millsec
    );
  },
  /**
   * ミリ秒をhh:MM:ss フォーマットに変換
   * @param duration
   * @returns {string} hh:MM:ss
   */
  convertMillisecondToHMS(duration) {
    if (!duration) {
      return "00:00:00";
    }

    const totalSec = Math.floor(duration / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    return (h < 10 ? "0" : "") + h + ":" + (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
  },
  checkChangedUserOptionCondition(self, changedOption, appData, userOptions) {
    if (appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
      switch (changedOption) {
        case "speechToText":
          if (userOptions.speechToText) {
            if (!appData.enableSpeechTextOption && !appData.enableSpeechTextTrial) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_speechToText_option")
              );
              userOptions.speechToText = false;
            }
          } else {
            if (userOptions.translation) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_disable_translation")
              );
              userOptions.speechToText = true;
              return;
            }
          }
          break;
        case "translation":
          if (userOptions.translation) {
            if (!appData.enableTranslationOption && !appData.enableTranslationTrial) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_translation_option")
              );
              userOptions.translation = false;
              return;
            }
            if (!userOptions.speechToText) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_enable_speechToText")
              );
              userOptions.translation = false;
              return;
            }
          }
          break;
        case "tracking":
          if (userOptions.tracking) {
            if (!appData.enableTrackingOption && !appData.enableTrackingTrial) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_location_tracking_option")
              );
              userOptions.tracking = false;
              return;
            }
          }
          break;
        case "mapTalk":
          if (userOptions.mapTalk) {
            if (!appData.enableMaptalkOption && !appData.enableMaptalkTrial) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_mapTalk_option")
              );
              userOptions.mapTalk = false;
              return;
            }
          }
          break;
        case "video":
          if (userOptions.video) {
            if (!appData.enableVideoOption && !appData.enableVideoTrial) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_video_option")
              );
              userOptions.video = false;
              return;
            }
          }
          break;
      }
    } else {
      switch (changedOption) {
        case "speechToText":
          if (userOptions.speechToText) {
            if (
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE ||
              appData.basicContract.planType == constants.LICENSE_PLAN_LIVE_LITE
            ) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_other_license_plan").replace(
                  "{licensePlan}",
                  "Talk Enterprise or Livecast Enterprise"
                )
              );
              userOptions.speechToText = false;
            }
          } else {
            if (userOptions.translation) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_disable_translation")
              );
              userOptions.speechToText = true;
              return;
            }
          }
          break;
        case "translation":
          if (userOptions.translation) {
            if (
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE ||
              appData.basicContract.planType == constants.LICENSE_PLAN_LIVE_LITE
            ) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_other_license_plan").replace(
                  "{licensePlan}",
                  "Talk Enterprise or Livecast Enterprise"
                )
              );
              userOptions.translation = false;
              return;
            }
            if (!userOptions.speechToText) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_enable_speechToText")
              );
              userOptions.translation = false;
              return;
            }
          }
          break;
        case "tracking":
          if (userOptions.tracking) {
            if (
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE ||
              appData.basicContract.planType == constants.LICENSE_PLAN_LIVE_LITE
            ) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_other_license_plan").replace(
                  "{licensePlan}",
                  "Talk Enterprise or Livecast Enterprise"
                )
              );
              userOptions.tracking = false;
              return;
            }
          }
          break;
        case "mapTalk":
          if (userOptions.mapTalk) {
            if (!appData.enableMaptalkOption && !appData.enableMaptalkTrial) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_mapTalk_option")
              );
              userOptions.mapTalk = false;
              return;
            }
          }
          break;
        case "video":
          if (userOptions.video) {
            if (
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE ||
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_ENT
            ) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_other_license_plan").replace(
                  "{licensePlan}",
                  "Livecast Enterprise"
                )
              );
              userOptions.video = false;
              return;
            }
          }
          break;
      }
    }
  },
  checkChangedGroupOptionCondition(
    self,
    changedOption,
    appData,
    groupOptions,
    savedOption,
    disableBySaml,
    processorDefinitionNeedsStt
  ) {
    const shouldSkipOptionLicenseCheck = appData.isRadioIntegrated === true;
    if (appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
      switch (changedOption) {
        case "speechToTextEngine":
          if (groupOptions.speechToTextEngine > 0) {
            if (disableBySaml) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_cannot_use_saml_group")
              );
              groupOptions.speechToTextEngine = savedOption.speechToTextEngine = 0;
              return;
            }
            if (!shouldSkipOptionLicenseCheck && !appData.enableSpeechTextTrial) {
              if (!appData.enableSpeechTextOption) {
                this.notifyMessage(
                  self,
                  "Warning",
                  this.getMessageText(self.$i18n, "error_need_speechToText_option")
                );
                groupOptions.speechToTextEngine = savedOption.speechToTextEngine = 0;
                return;
              }
            }
          } else {
            if (groupOptions.translationEngine > 0) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_disable_translation")
              );
              groupOptions.speechToTextEngine = savedOption.speechToTextEngine;
              return;
            }
            if (processorDefinitionNeedsStt) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_disable_ai_definitions")
              );
              groupOptions.speechToTextEngine = savedOption.speechToTextEngine;
              return;
            }
          }
          savedOption.speechToTextEngine = groupOptions.speechToTextEngine;
          break;
        case "translationEngine":
          if (groupOptions.translationEngine > 0) {
            if (disableBySaml) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_cannot_use_saml_group")
              );
              groupOptions.translationEngine = savedOption.speechToTextEngine = 0;
              return;
            }
            if (groupOptions.speechToTextEngine == 0) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_enable_speechToText")
              );
              groupOptions.translationEngine = savedOption.translationEngine;
              return;
            }
            if (!shouldSkipOptionLicenseCheck && !appData.enableTranslationTrial) {
              if (!appData.enableTranslationOption) {
                this.notifyMessage(
                  self,
                  "Warning",
                  this.getMessageText(self.$i18n, "error_need_translation_option")
                );
                groupOptions.translationEngine = savedOption.translationEngine = 0;
                return;
              }
            }
          }
          savedOption.translationEngine = groupOptions.translationEngine;
          break;
        case "location":
          if (!groupOptions.location) {
            if (groupOptions.mapTalk) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_disable_mapTalk")
              );
              groupOptions.location = true;
              return;
            }
          }
          break;
        case "mapTalk":
          if (groupOptions.mapTalk) {
            if (disableBySaml) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_cannot_use_saml_group")
              );
              groupOptions.mapTalk = savedOption.mapTalk = false;
              return;
            }
            if (!appData.enableMaptalkTrial) {
              if (!appData.enableMaptalkOption) {
                this.notifyMessage(
                  self,
                  "Warning",
                  this.getMessageText(self.$i18n, "error_need_mapTalk_option")
                );
                groupOptions.mapTalk = false;
                return;
              }
            }
            if (!groupOptions.location) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_location_option")
              );
              groupOptions.mapTalk = false;
              return;
            }
          }
          break;
        case "video":
          if (groupOptions.video) {
            if (disableBySaml) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_cannot_use_saml_group")
              );
              groupOptions.video = savedOption.video = false;
              return;
            }
            if (!appData.enableVideoTrial) {
              if (!appData.enableVideoOption) {
                this.notifyMessage(
                  self,
                  "Warning",
                  this.getMessageText(self.$i18n, "error_need_video_option")
                );
                groupOptions.video = false;
                return;
              }
            }
          }
        case "subGroup":
          savedOption.subGroup = groupOptions.subGroup;
          break;
      }
    } else {
      switch (changedOption) {
        case "speechToTextEngine":
          if (groupOptions.speechToTextEngine > 0) {
            if (
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE ||
              appData.basicContract.planType == constants.LICENSE_PLAN_LIVE_LITE
            ) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_other_license_plan").replace(
                  "{licensePlan}",
                  "Talk Enterprise or Livecast Enterprise"
                )
              );
              groupOptions.speechToTextEngine = savedOption.speechToTextEngine = 0;
              return;
            }
            if (disableBySaml) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_cannot_use_saml_group")
              );
              groupOptions.speechToTextEngine = savedOption.speechToTextEngine = 0;
              return;
            }
            if (!shouldSkipOptionLicenseCheck && !appData.enableSpeechTextTrial) {
              if (!appData.enableSpeechTextOption) {
                this.notifyMessage(
                  self,
                  "Warning",
                  this.getMessageText(self.$i18n, "error_need_speechToText_option")
                );
                groupOptions.speechToTextEngine = savedOption.speechToTextEngine = 0;
                return;
              }
            }
          } else {
            if (groupOptions.translationEngine > 0) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_disable_translation")
              );
              groupOptions.speechToTextEngine = savedOption.speechToTextEngine;
              return;
            }
            if (processorDefinitionNeedsStt) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_disable_ai_definitions")
              );
              groupOptions.speechToTextEngine = savedOption.speechToTextEngine;
              return;
            }
          }
          savedOption.speechToTextEngine = groupOptions.speechToTextEngine;
          break;
        case "translationEngine":
          if (groupOptions.translationEngine > 0) {
            if (
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE ||
              appData.basicContract.planType == constants.LICENSE_PLAN_LIVE_LITE
            ) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_other_license_plan").replace(
                  "{licensePlan}",
                  "Talk Enterprise or Livecast Enterprise"
                )
              );
              groupOptions.translationEngine = savedOption.speechToTextEngine = 0;
              return;
            }
            if (disableBySaml) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_cannot_use_saml_group")
              );
              groupOptions.translationEngine = savedOption.speechToTextEngine = 0;
              return;
            }
            if (groupOptions.speechToTextEngine == 0) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_enable_speechToText")
              );
              groupOptions.translationEngine = savedOption.translationEngine;
              return;
            }
            if (!shouldSkipOptionLicenseCheck && !appData.enableTranslationTrial) {
              if (!appData.enableTranslationOption) {
                this.notifyMessage(
                  self,
                  "Warning",
                  this.getMessageText(self.$i18n, "error_need_translation_option")
                );
                groupOptions.translationEngine = savedOption.translationEngine = 0;
                return;
              }
            }
          }
          savedOption.translationEngine = groupOptions.translationEngine;
          break;
        case "location":
          if (!groupOptions.location) {
            if (groupOptions.mapTalk) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_disable_mapTalk")
              );
              groupOptions.location = true;
              return;
            }
          }
          break;
        case "mapTalk":
          if (groupOptions.mapTalk) {
            if (disableBySaml) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_cannot_use_saml_group")
              );
              groupOptions.mapTalk = savedOption.mapTalk = false;
              return;
            }
            if (!appData.enableMaptalkTrial) {
              if (!appData.enableMaptalkOption) {
                this.notifyMessage(
                  self,
                  "Warning",
                  this.getMessageText(self.$i18n, "error_need_mapTalk_option")
                );
                groupOptions.mapTalk = false;
                return;
              }
            }
            if (!groupOptions.location) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_location_option")
              );
              groupOptions.mapTalk = false;
              return;
            }
          }
          break;
        case "video":
          if (groupOptions.video) {
            if (
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE ||
              appData.basicContract.planType == constants.LICENSE_PLAN_TALK_ENT
            ) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_need_other_license_plan").replace(
                  "{licensePlan}",
                  "Livecast Enterprise"
                )
              );
              groupOptions.video = savedOption.video = false;
              return;
            }
            if (disableBySaml) {
              this.notifyMessage(
                self,
                "Warning",
                this.getMessageText(self.$i18n, "error_cannot_use_saml_group")
              );
              groupOptions.video = savedOption.video = false;
              return;
            }
            if (!appData.enableVideoTrial) {
              if (!appData.enableVideoOption) {
                this.notifyMessage(
                  self,
                  "Warning",
                  this.getMessageText(self.$i18n, "error_need_video_option")
                );
                groupOptions.video = false;
                return;
              }
            }
          }
          break;
        case "subGroup":
          savedOption.subGroup = groupOptions.subGroup;
          break;
      }
    }
  },
  isPlanUpgrade(currentPlan, newPlan) {
    switch (currentPlan) {
      case constants.LICENSE_PLAN_TALK_LITE:
        switch (newPlan) {
          case constants.LICENSE_PLAN_TALK_ENT:
          case constants.LICENSE_PLAN_LIVE_LITE:
          case constants.LICENSE_PLAN_LIVE_ENT:
            return true;
          default:
            return false;
        }
      case constants.LICENSE_PLAN_TALK_ENT:
        switch (newPlan) {
          case constants.LICENSE_PLAN_TALK_LITE:
            return false;
          case constants.LICENSE_PLAN_LIVE_LITE:
            return false;
          case constants.LICENSE_PLAN_LIVE_ENT:
            return true;
          default:
            return false;
        }
      case constants.LICENSE_PLAN_LIVE_LITE:
        switch (newPlan) {
          case constants.LICENSE_PLAN_TALK_LITE:
            return false;
          case constants.LICENSE_PLAN_TALK_ENT:
            return false;
          case constants.LICENSE_PLAN_LIVE_ENT:
            return true;
          default:
            return false;
        }
      case constants.LICENSE_PLAN_LIVE_ENT:
        return false;
    }
  },
  isExceedPaymentLimit(self, purchasePeriodType, totalAmount) {
    switch (Number(purchasePeriodType)) {
      case constants.PURCHASE_PERIOD_MONTHLY:
        if (Number(totalAmount) > constants.CREDIT_UPPER_LIMIT_MONTH) {
          this.notifyMessage(
            self,
            "Warning",
            "月額利用料金が30万円を超える場合は、購入できません。上限を超えて購入したい場合は、お問い合わせください。"
          );
          return true;
        }
        break;
      case constants.PURCHASE_PERIOD_YEARLY:
        if (Number(totalAmount) > constants.CREDIT_UPPER_LIMIT_YEAR) {
          this.notifyMessage(
            self,
            "Warning",
            "カード決済金額の上限を超えているため、購入できません。 "
          );
          return true;
        }
        break;
    }
    return false;
  },
  isTenantConnectAdmin(appData, tenantId) {
    for (let importTenant of appData.importedTenantList) {
      if (importTenant.tenantId == tenantId) {
        if (importTenant.wantUserId == appData.loginUserObjectId) {
          return true;
        }
      }
    }
    return false;
  },
  isSmartPhoneScreen() {
    if (window.innerWidth <= 750) {
      return true;
    } else {
      return false;
    }
  },
  isEnableOption(appData, type) {
    switch (appData.basicContract.planType) {
      case constants.LICENSE_PLAN_SEPARATE:
        let optionContract = appData.numberContract.filter(function (element) {
          return element.type == type;
        });
        if (optionContract.length > 0) {
          if (optionContract[0].currentMax > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
        break;
      case constants.LICENSE_PLAN_TALK_ENT:
        if (type == constants.LICENSE_VIDEO) {
          return false;
        } else {
          return true;
        }
      case constants.LICENSE_PLAN_ENTERPRISE:
      case constants.LICENSE_PLAN_LIVE_ENT:
        return true;
        break;
      default:
        return false;
    }
  },
  isOffPlanLicense(licenseType) {
    return (
      licenseType === constants.OFF_PLAN_LICENSE_BELL ||
      licenseType === constants.OFF_PLAN_LICENSE_DEDICATED ||
      licenseType === constants.OFF_PLAN_LICENSE_CALL_CENTER ||
      licenseType === constants.OFF_PLAN_LICENSE_BUDDY_BOT_API ||
      licenseType === constants.OFF_PLAN_LICENSE_MAP_IMAGE_OVERLAY ||
      licenseType === constants.OFF_PLAN_LICENSE_CALL ||
      licenseType === constants.OFF_PLAN_LICENSE_SAFETY_SUPPORT
    );
  },

  getTypeByProcessorClassName(className) {
    switch (className) {
      case "stt.SttFallbackProcessor":
        return 1;
      case "stt.Google.GoogleSTT":
      case "translate.Google.GoogleTranslate":
        return 2;
      case "stt.Azure.AzureSTT":
      case "translate.Azure.AzureTranslate":
        return 3;
      case "stt.AdvancedMedia.AdvancedMediaSTT":
      case "translate.DeepL.DeepLTranslate":
        return 4;
      default:
        return 0;
    }
  },

  getSpeechToTextEngineList(i18n) {
    return [
      { type: 0, displayName: this.getMessageText(i18n, "item_value_nonUsed") },
      { type: 1, displayName: this.getMessageText(i18n, "item_auto") },
      { type: 4, displayName: "AmiVoice" },
      { type: 2, displayName: "Google Speech To Text" },
      { type: 3, displayName: "Azure Speech To Text" },
    ];
  },
  getSpeechToTextEngineName(i18n, engineType) {
    let list = this.getSpeechToTextEngineList(i18n);
    for (let item of list) {
      if (engineType === item.type) {
        return item.displayName;
      }
    }
    return undefined;
  },
  getSpeechToTextEngineListForPlanLicense(i18n) {
    return [
      { type: 0, displayName: this.getMessageText(i18n, "item_value_nonUsed") },
      { type: 1, displayName: this.getMessageText(i18n, "item_auto") },
      { type: 4, displayName: "AmiVoice" },
      { type: 3, displayName: "Azure Speech To Text" },
    ];
  },
  getTranslationEngineList(i18n) {
    return [
      { type: 0, displayName: this.getMessageText(i18n, "item_value_nonUsed") },
      { type: 1, displayName: this.getMessageText(i18n, "item_auto") },
      { type: 2, displayName: "Google Translate" },
      { type: 3, displayName: "Azure Translator Text" },
      { type: 4, displayName: "DeepL" },
    ];
  },
  getTranslationEngineName(i18n, engineType) {
    let list = this.getTranslationEngineList(i18n);
    for (let item of list) {
      if (engineType === item.type) {
        return item.displayName;
      }
    }
    return undefined;
  },
  getSaveOptions(i18n) {
    return [
      { value: true, displayName: this.getMessageText(i18n, "item_save") },
      { value: false, displayName: this.getMessageText(i18n, "item_no_save") },
    ];
  },
  getTalkTypeList(i18n) {
    return [
      { value: null, label: this.getMessageText(i18n, "item_option_simplex") },
      { value: "multi", label: this.getMessageText(i18n, "item_option_fullDuplexCall") },
      { value: "interrupt", label: this.getMessageText(i18n, "item_option_interrupt") },
    ];
  },
  // Call gif カテゴリー
  getGifCategoryTypeList(i18n) {
    return [
      { value: 1, label: this.getMessageText(i18n, "item_option_buddycomCall_station_gif") },
      { value: 2, label: this.getMessageText(i18n, "item_option_buddycomCall_shop_gif") },
      { value: 3, label: this.getMessageText(i18n, "item_option_buddycomCall_doctor_gif") },
      { value: 4, label: this.getMessageText(i18n, "item_option_buddycomCall_nurse_gif") },
    ];
  },
  getLongTalkTypeList(i18n) {
    return [{ value: "multi", label: this.getMessageText(i18n, "item_option_fullDuplexCall") }];
  },
  getEasyLoginTypeList(i18n) {
    return [
      { value: 0, label: this.getMessageText(i18n, "item_value_nonUsed") },
      {
        value: constants.EASY_LOGIN_TYPE_SELECTION,
        label: this.getMessageText(i18n, "item_option_easyLogin_selection"),
      },
      {
        value: constants.EASY_LOGIN_TYPE_RANDOM,
        label: this.getMessageText(i18n, "item_option_easyLogin_random"),
      },
    ];
  },
  sortUserTalkGroup(appData, userTalkGroupList, sortType) {
    let result = {
      sortedUserTalkGroup: [],
      defaultTalkGroup: { tenantId: 0, talkGroupId: 0 },
      defaultSecondGroup: { tenantId: 0, talkGroupId: 0 },
    };
    if ((appData.importedTenantList.length == 0) & (appData.exportedTenantList.length == 0)) {
      for (let userTalkGroup of userTalkGroupList) {
        result.sortedUserTalkGroup.push({
          id: userTalkGroup.talkgroupTenantId + "-" + userTalkGroup.talkgroupId,
          userTenantId: userTalkGroup.userTenantId,
          userId: userTalkGroup.userId,
          userName: userTalkGroup.userName,
          userTenantName: appData.tenantList[0].name,
          tenantId: userTalkGroup.talkgroupTenantId,
          talkgroupId: userTalkGroup.talkgroupId,
          talkgroupName: userTalkGroup.talkgroupName,
          talkgroupTenantName: appData.tenantList[0].name,
          mandatoryFlag: userTalkGroup.mandatoryFlag > 0,
          voiceReportFlag: userTalkGroup.voiceReportFlag > 0,
          emergencyFlag: userTalkGroup.emergencyFlag > 0,
          powerOnFlag: userTalkGroup.powerOnFlag > 0,
          listenOnlyFlag: userTalkGroup.listenOnlyFlag > 0,
          displayName: userTalkGroup.displayName,
          defaultFlag: userTalkGroup.defaultFlag,
          defaultSecondFlag: userTalkGroup.defaultSecondFlag,
          joinedSubGroupIdList: userTalkGroup.joinedSubGroupIdList,
          optionFlag: userTalkGroup.optionFlag,
        });
        if (userTalkGroup.defaultFlag) {
          result.defaultTalkGroup.tenantId = userTalkGroup.talkgroupTenantId;
          result.defaultTalkGroup.talkGroupId = userTalkGroup.talkgroupId;
        }
        if (userTalkGroup.defaultSecondFlag) {
          result.defaultSecondGroup.tenantId = userTalkGroup.talkgroupTenantId;
          result.defaultSecondGroup.talkGroupId = userTalkGroup.talkgroupId;
        }
      }
      let _this = this;
      result.sortedUserTalkGroup.sort(function (o1, o2) {
        let e1 = o1.userName != null ? o1.userName : o1.talkgroupName;
        let e2 = o2.userName != null ? o2.userName : o2.talkgroupName;
        return _this.compareStringWithNumber(e1, e2);
      });
    } else {
      let self = this;
      let myTenantUserTalkGroup = userTalkGroupList.filter(function (userTalkGroup) {
        if (sortType == constants.OBJECT_USER) {
          return userTalkGroup.userTenantId == appData.tenantList[0].tenantId;
        } else {
          return userTalkGroup.talkgroupTenantId == appData.tenantList[0].tenantId;
        }
      });
      for (let userTalkGroup of myTenantUserTalkGroup) {
        result.sortedUserTalkGroup.push({
          id: userTalkGroup.talkgroupTenantId + "-" + userTalkGroup.talkgroupId,
          userTenantId: userTalkGroup.userTenantId,
          userId: userTalkGroup.userId,
          userName: userTalkGroup.userName,
          userTenantName: this.getTenantName(appData, userTalkGroup.userTenantId),
          tenantId: userTalkGroup.talkgroupTenantId,
          talkgroupId: userTalkGroup.talkgroupId,
          talkgroupName: userTalkGroup.talkgroupName,
          talkgroupTenantName: this.getTenantName(appData, userTalkGroup.talkgroupTenantId),
          defaultFlag: userTalkGroup.defaultFlag,
          defaultSecondFlag: userTalkGroup.defaultSecondFlag,
          mandatoryFlag: userTalkGroup.mandatoryFlag > 0,
          voiceReportFlag: userTalkGroup.voiceReportFlag > 0,
          emergencyFlag: userTalkGroup.emergencyFlag > 0,
          powerOnFlag: userTalkGroup.powerOnFlag > 0,
          listenOnlyFlag: userTalkGroup.listenOnlyFlag > 0,
          displayName: userTalkGroup.displayName,
          joinedSubGroupIdList: userTalkGroup.joinedSubGroupIdList,
          optionFlag: userTalkGroup.optionFlag,
        });
        if (userTalkGroup.defaultFlag) {
          result.defaultTalkGroup.tenantId = userTalkGroup.talkgroupTenantId;
          result.defaultTalkGroup.talkGroupId = userTalkGroup.talkgroupId;
        }
        if (userTalkGroup.defaultSecondFlag) {
          result.defaultSecondGroup.tenantId = userTalkGroup.talkgroupTenantId;
          result.defaultSecondGroup.talkGroupId = userTalkGroup.talkgroupId;
        }
      }
      let _this = this;
      result.sortedUserTalkGroup.sort(function (o1, o2) {
        let e1 = o1.userName != null ? o1.userName : o1.talkgroupName;
        let e2 = o2.userName != null ? o2.userName : o2.talkgroupName;
        return _this.compareStringWithNumber(e1, e2);
      });
      let otherTenantUserTalkGroup = userTalkGroupList.filter(function (userTalkGroup) {
        if (sortType == constants.OBJECT_USER) {
          return userTalkGroup.userTenantId != appData.tenantList[0].tenantId;
        } else {
          return userTalkGroup.talkgroupTenantId != appData.tenantList[0].tenantId;
        }
      });
      var otherArray = [];
      for (let userTalkGroup of otherTenantUserTalkGroup) {
        otherArray.push({
          id: userTalkGroup.talkgroupTenantId + "-" + userTalkGroup.talkgroupId,
          userTenantId: userTalkGroup.userTenantId,
          userId: userTalkGroup.userId,
          userName: userTalkGroup.userName,
          userTenantName: this.getTenantName(appData, userTalkGroup.userTenantId),
          tenantId: userTalkGroup.talkgroupTenantId,
          talkgroupId: userTalkGroup.talkgroupId,
          talkgroupName: userTalkGroup.talkgroupName,
          talkgroupTenantName: this.getTenantName(appData, userTalkGroup.talkgroupTenantId),
          defaultFlag: userTalkGroup.defaultFlag,
          defaultSecondFlag: userTalkGroup.defaultSecondFlag,
          mandatoryFlag: userTalkGroup.mandatoryFlag > 0,
          voiceReportFlag: userTalkGroup.voiceReportFlag > 0,
          emergencyFlag: userTalkGroup.emergencyFlag > 0,
          powerOnFlag: userTalkGroup.powerOnFlag > 0,
          listenOnlyFlag: userTalkGroup.listenOnlyFlag > 0,
          displayName: userTalkGroup.displayName,
          joinedSubGroupIdList: userTalkGroup.joinedSubGroupIdList,
          optionFlag: userTalkGroup.optionFlag,
          type: userTalkGroup.type,
        });
        if (userTalkGroup.defaultFlag) {
          result.defaultTalkGroup.tenantId = userTalkGroup.talkgroupTenantId;
          result.defaultTalkGroup.talkGroupId = userTalkGroup.talkgroupId;
        }
        if (userTalkGroup.defaultSecondFlag) {
          result.defaultSecondGroup.tenantId = userTalkGroup.talkgroupTenantId;
          result.defaultSecondGroup.talkGroupId = userTalkGroup.talkgroupId;
        }
      }
      otherArray.sort(function (o1, o2) {
        var e1;
        var e2;
        if (sortType == constants.OBJECT_USER) {
          e1 = o1.userTenantName + " " + o1.userName;
          e2 = o2.userTenantName + " " + o2.userName;
        } else {
          e1 = o1.talkgroupTenantName + " " + o1.talkgroupName;
          e2 = o2.talkgroupTenantName + " " + o2.talkgroupName;
        }
        return _this.compareStringWithNumber(e1, e2);
      });
      for (let elem of otherArray) {
        result.sortedUserTalkGroup.push(elem);
      }
    }
    return result;
  },
  getCountryList() {
    return [
      { value: "AFG", alpha2: "AF", displayName: "AFGHANISTAN", timeOffset: 4 },
      { value: "ALB", alpha2: "AL", displayName: "ALBANIA", timeOffset: 1 },
      { value: "DZA", alpha2: "DZ", displayName: "ALGERIA", timeOffset: 1 },
      { value: "AND", alpha2: "AD", displayName: "ANDORRA", timeOffset: 1 },
      { value: "AGO", alpha2: "AO", displayName: "ANGOLA", timeOffset: 1 },
      { value: "ATG", alpha2: "AG", displayName: "ANTIGUA AND BARBUDA", timeOffset: -4 },
      { value: "ARG", alpha2: "AR", displayName: "ARGENTINA", timeOffset: -3 },
      { value: "ARM", alpha2: "AM", displayName: "ARMENIA", timeOffset: 4 },
      { value: "AUS", alpha2: "AU", displayName: "AUSTRALIA", timeOffset: 5 },
      { value: "AUT", alpha2: "AT", displayName: "AUSTRIA", timeOffset: 1 },
      { value: "AZE", alpha2: "AZ", displayName: "AZERBAIDJAN", timeOffset: 4 },
      { value: "BHS", alpha2: "BS", displayName: "BAHAMAS", timeOffset: -5 },
      { value: "BHR", alpha2: "BH", displayName: "BAHRAIN", timeOffset: 3 },
      { value: "BGD", alpha2: "BD", displayName: "BANGLADESH", timeOffset: 6 },
      { value: "BRB", alpha2: "BB", displayName: "BARBADOS", timeOffset: -4 },
      { value: "BLR", alpha2: "BY", displayName: "BELARUS", timeOffset: 3 },
      { value: "BEL", alpha2: "BE", displayName: "BELGIUM", timeOffset: 1 },
      { value: "BLZ", alpha2: "BZ", displayName: "BELIZE", timeOffset: -6 },
      { value: "BEN", alpha2: "BJ", displayName: "BENIN", timeOffset: 1 },
      { value: "BTN", alpha2: "BT", displayName: "BHUTAN", timeOffset: 6 },
      { value: "BOL", alpha2: "BO", displayName: "BOLIVIA", timeOffset: -4 },
      { value: "BIH", alpha2: "BA", displayName: "BOSNIA AND HERZEGOVINA", timeOffset: 1 },
      { value: "BWA", alpha2: "BW", displayName: "BOTSWANA", timeOffset: 2 },
      { value: "BRA", alpha2: "BR", displayName: "BRAZIL", timeOffset: -3 },
      { value: "BRN", alpha2: "BN", displayName: "BRUNEI DARUSSALAM", timeOffset: 8 },
      { value: "BGR", alpha2: "BG", displayName: "BULGARIA", timeOffset: 2 },
      { value: "BFA", alpha2: "BF", displayName: "BURKINA FASO", timeOffset: 0 },
      { value: "BDI", alpha2: "bI", displayName: "BURUNDI", timeOffset: 2 },
      { value: "KHM", alpha2: "KH", displayName: "CAMBODIA", timeOffset: 7 },
      { value: "CMR", alpha2: "CM", displayName: "CAMEROON", timeOffset: 1 },
      { value: "CAN", alpha2: "CA", displayName: "CANADA", timeOffset: -6 },
      { value: "CPV", alpha2: "CV", displayName: "CAPE VERDE", timeOffset: -1 },
      { value: "CAF", alpha2: "CF", displayName: "CENTRAL AFRICAN REP.", timeOffset: 1 },
      { value: "TCD", alpha2: "TD", displayName: "CHAD", timeOffset: 1 },
      { value: "CHL", alpha2: "CL", displayName: "CHILE", timeOffset: -6 },
      { value: "CHN", alpha2: "CN", displayName: "CHINA", timeOffset: 8 },
      { value: "COL", alpha2: "CO", displayName: "COLOMBIA", timeOffset: -5 },
      { value: "DMA", alpha2: "DM", displayName: "COMMOMWEALTH OF DOMINICA", timeOffset: -4 },
      { value: "COM", alpha2: "KM", displayName: "COMOROS", timeOffset: 3 },
      { value: "COG", alpha2: "CG", displayName: "CONGO", timeOffset: 1 },
      { value: "COK", alpha2: "CK", displayName: "COOK ISLANDS", timeOffset: -10 },
      { value: "CRI", alpha2: "CR", displayName: "COSTA RICA", timeOffset: -6 },
      { value: "CIV", alpha2: "CI", displayName: "COTE D'IVOIRE", timeOffset: 0 },
      { value: "HRV", alpha2: "HR", displayName: "CROATIA", timeOffset: 1 },
      { value: "CUB", alpha2: "CU", displayName: "CUBA", timeOffset: -5 },
      { value: "CYP", alpha2: "CY", displayName: "CYPRUS", timeOffset: 2 },
      { value: "CZE", alpha2: "CZ", displayName: "CZECH", timeOffset: 1 },
      { value: "COD", alpha2: "CD", displayName: "DEM. REP. OF CONGO", timeOffset: 1 },
      { value: "DNK", alpha2: "DK", displayName: "DENMARK", timeOffset: 1 },
      { value: "DJI", alpha2: "DJ", displayName: "DJIBOUTI", timeOffset: 3 },
      { value: "DOM", alpha2: "DO", displayName: "DOMINICAN REPUBLIC", timeOffset: -4 },
      { value: "ECU", alpha2: "EC", displayName: "ECUADOR", timeOffset: -5 },
      { value: "EGY", alpha2: "EG", displayName: "EGYPT", timeOffset: 2 },
      { value: "SLV", alpha2: "SV", displayName: "EL SALVADOR", timeOffset: -6 },
      { value: "GNQ", alpha2: "GQ", displayName: "EQUATORIAL GUINEA", timeOffset: 1 },
      { value: "ERI", alpha2: "ER", displayName: "ERITREA", timeOffset: 3 },
      { value: "EST", alpha2: "EE", displayName: "ESTONIA", timeOffset: 2 },
      { value: "ETH", alpha2: "ET", displayName: "ETHIOPIA", timeOffset: 3 },
      { value: "FJI", alpha2: "FJ", displayName: "FIJI", timeOffset: 12 },
      { value: "FIN", alpha2: "FI", displayName: "FINLAND", timeOffset: 2 },
      { value: "MKD", alpha2: "MK", displayName: "REPUBLIC OF NORTH MACEDONIA", timeOffset: 1 },
      { value: "FRA", alpha2: "FR", displayName: "FRANCE", timeOffset: 1 },
      { value: "GAB", alpha2: "GA", displayName: "GABON", timeOffset: 1 },
      { value: "GMB", alpha2: "GM", displayName: "GAMBIA", timeOffset: 0 },
      { value: "GEO", alpha2: "GE", displayName: "GEORGIA", timeOffset: 4 },
      { value: "DEU", alpha2: "DE", displayName: "GERMANY", timeOffset: 1 },
      { value: "GHA", alpha2: "GH", displayName: "GHANA", timeOffset: 0 },
      { value: "GRC", alpha2: "GR", displayName: "GREECE", timeOffset: 2 },
      { value: "GRD", alpha2: "GD", displayName: "GRENADA", timeOffset: -4 },
      { value: "GTM", alpha2: "GT", displayName: "GUATEMALA", timeOffset: -6 },
      { value: "GIN", alpha2: "GN", displayName: "GUINEA", timeOffset: 0 },
      { value: "GNB", alpha2: "GW", displayName: "GUINEA-BISSAU", timeOffset: 0 },
      { value: "GUY", alpha2: "GY", displayName: "GUYANA", timeOffset: -4 },
      { value: "HTI", alpha2: "HT", displayName: "HAITI", timeOffset: -5 },
      { value: "HND", alpha2: "HN", displayName: "HONDURAS", timeOffset: -6 },
      { value: "HUN", alpha2: "HU", displayName: "HUNGARY", timeOffset: 1 },
      { value: "ISL", alpha2: "IS", displayName: "ICELAND", timeOffset: 0 },
      { value: "WSM", alpha2: "WS", displayName: "INDEPENDENT STATE OF SAMOA", timeOffset: 13 },
      { value: "IND", alpha2: "IN", displayName: "INDIA", timeOffset: 5 },
      { value: "IDN", alpha2: "ID", displayName: "INDONESIA", timeOffset: 7 },
      { value: "IRN", alpha2: "IR", displayName: "IRAN", timeOffset: 3 },
      { value: "IRQ", alpha2: "IQ", displayName: "IRAQ", timeOffset: 3 },
      { value: "IRL", alpha2: "IE", displayName: "IRELAND", timeOffset: 0 },
      { value: "ISR", alpha2: "IL", displayName: "ISRAEL", timeOffset: 2 },
      { value: "ITA", alpha2: "IT", displayName: "ITALY", timeOffset: 1 },
      { value: "JAM", alpha2: "JM", displayName: "JAMAICA", timeOffset: -5 },
      { value: "JPN", alpha2: "JP", displayName: "JAPAN", timeOffset: 9 },
      { value: "JOR", alpha2: "JO", displayName: "JORDAN", timeOffset: 2 },
      { value: "KAZ", alpha2: "KZ", displayName: "KAZAKHSTAN", timeOffset: 6 },
      { value: "KEN", alpha2: "KE", displayName: "KENYA", timeOffset: 3 },
      { value: "KIR", alpha2: "KI", displayName: "KIRIBATI", timeOffset: 12 },
      { value: "KOR", alpha2: "KR", displayName: "KOREA (REP. OF KOREA)", timeOffset: 9 },
      { value: "KWT", alpha2: "KW", displayName: "KUWAIT", timeOffset: 3 },
      { value: "KGZ", alpha2: "KG", displayName: "KYRGYZSTAN", timeOffset: 6 },
      { value: "LAO", alpha2: "LA", displayName: "LAOS", timeOffset: 7 },
      { value: "LVA", alpha2: "LV", displayName: "LATVIA", timeOffset: 2 },
      { value: "LBN", alpha2: "LB", displayName: "LEBANON", timeOffset: 2 },
      { value: "LSO", alpha2: "LS", displayName: "LESOTHO", timeOffset: 2 },
      { value: "LBR", alpha2: "LR", displayName: "LIBERIA", timeOffset: 0 },
      { value: "LBY", alpha2: "LY", displayName: "LIBYA", timeOffset: 2 },
      { value: "LIE", alpha2: "LI", displayName: "LIECHTENSTEIN", timeOffset: 1 },
      { value: "LTU", alpha2: "LT", displayName: "LITHUANIA", timeOffset: 2 },
      { value: "LUX", alpha2: "LU", displayName: "LUXEMBOURG", timeOffset: 1 },
      { value: "MDG", alpha2: "MG", displayName: "MADAGASCAR", timeOffset: 3 },
      { value: "MWI", alpha2: "MW", displayName: "MALAWI", timeOffset: 2 },
      { value: "MYS", alpha2: "MY", displayName: "MALAYSIA", timeOffset: 8 },
      { value: "MDV", alpha2: "MV", displayName: "MALDIVES", timeOffset: 5 },
      { value: "MLI", alpha2: "ML", displayName: "MALI", timeOffset: 0 },
      { value: "MLT", alpha2: "MT", displayName: "MALTA", timeOffset: 1 },
      { value: "MRT", alpha2: "MR", displayName: "MAURITANIA", timeOffset: 0 },
      { value: "MUS", alpha2: "MU", displayName: "MAURITIUS", timeOffset: 4 },
      { value: "MEX", alpha2: "MX", displayName: "MEXICO", timeOffset: -6 },
      { value: "FSM", alpha2: "FM", displayName: "MICRONESIA", timeOffset: 11 },
      { value: "MDA", alpha2: "MD", displayName: "MOLDOVA", timeOffset: 2 },
      { value: "MCO", alpha2: "MC", displayName: "MONACO", timeOffset: 1 },
      { value: "MNG", alpha2: "MN", displayName: "MONGOLIA", timeOffset: 8 },
      { value: "MNE", alpha2: "ME", displayName: "MONTENEGRO", timeOffset: 1 },
      { value: "MAR", alpha2: "MA", displayName: "MOROCCO", timeOffset: 1 },
      { value: "MOZ", alpha2: "MZ", displayName: "MOZAMBIQUE", timeOffset: 2 },
      { value: "MMR", alpha2: "MM", displayName: "MYANMAR", timeOffset: 6 },
      { value: "NAM", alpha2: "NA", displayName: "NAMIBIA", timeOffset: 1 },
      { value: "NRU", alpha2: "NR", displayName: "NAURU", timeOffset: 12 },
      { value: "NPL", alpha2: "NP", displayName: "NEPAL", timeOffset: 6 },
      { value: "NLD", alpha2: "NL", displayName: "NETHERLANDS", timeOffset: 1 },
      { value: "NZL", alpha2: "NZ", displayName: "NEW ZEALAND", timeOffset: 12 },
      { value: "NIC", alpha2: "NI", displayName: "NICARAGUA", timeOffset: -6 },
      { value: "NER", alpha2: "NE", displayName: "NIGER", timeOffset: 1 },
      { value: "NGA", alpha2: "NG", displayName: "NIGERIA", timeOffset: 1 },
      { value: "NOR", alpha2: "NO", displayName: "NORWAY", timeOffset: 1 },
      { value: "OMN", alpha2: "OM", displayName: "OMAN", timeOffset: 4 },
      { value: "PAK", alpha2: "PK", displayName: "PAKISTAN", timeOffset: 5 },
      { value: "PLW", alpha2: "PW", displayName: "PALAU", timeOffset: 9 },
      {
        value: "PSE",
        alpha2: "PS",
        displayName: "PALESTINE LIBERATION ORGANIZATION",
        timeOffset: 2,
      },
      { value: "PAN", alpha2: "PA", displayName: "PANAMA", timeOffset: -5 },
      { value: "PNG", alpha2: "PG", displayName: "PAPUA NEW GUINEA", timeOffset: 10 },
      { value: "PRY", alpha2: "PY", displayName: "PARAGUAY", timeOffset: -4 },
      { value: "PER", alpha2: "PE", displayName: "PERU", timeOffset: -5 },
      { value: "PHL", alpha2: "PH", displayName: "PHILIPPINES", timeOffset: 8 },
      { value: "POL", alpha2: "PL", displayName: "POLAND", timeOffset: 1 },
      { value: "PRT", alpha2: "PT", displayName: "PORTUGAL", timeOffset: -1 },
      { value: "QAT", alpha2: "QA", displayName: "QATAR", timeOffset: 3 },
      { value: "MHL", alpha2: "MH", displayName: "REP. OF THE MARSHALL IS.", timeOffset: 12 },
      { value: "ROU", alpha2: "RO", displayName: "ROMANIA", timeOffset: 2 },
      { value: "RUS", alpha2: "RU", displayName: "RUSSIA FEDERATION", timeOffset: 3 },
      { value: "RWA", alpha2: "RW", displayName: "RWANDA", timeOffset: 2 },
      { value: "SMR", alpha2: "SM", displayName: "SAN MARINO", timeOffset: 1 },
      { value: "STP", alpha2: "ST", displayName: "SAO TOME AND PRINCIPE", timeOffset: 0 },
      { value: "SAU", alpha2: "SA", displayName: "SAUDI ARABIA", timeOffset: 3 },
      { value: "SEN", alpha2: "SN", displayName: "SENEGAL", timeOffset: 0 },
      { value: "SRB", alpha2: "RS", displayName: "SERBIA", timeOffset: 1 },
      { value: "SYC", alpha2: "SC", displayName: "SEYCHELLES", timeOffset: 4 },
      { value: "SLE", alpha2: "SL", displayName: "SIERRA LEONE", timeOffset: 0 },
      { value: "SGP", alpha2: "SG", displayName: "SINGAPORE", timeOffset: 8 },
      { value: "SVK", alpha2: "SK", displayName: "SLOVAKIA", timeOffset: 1 },
      { value: "SVN", alpha2: "SI", displayName: "SLOVENIA", timeOffset: 1 },
      { value: "SLB", alpha2: "SB", displayName: "SOLOMON ISLANDS", timeOffset: 11 },
      { value: "SOM", alpha2: "SO", displayName: "SOMALIA", timeOffset: 3 },
      { value: "ZAF", alpha2: "ZA", displayName: "SOUTH AFRICA", timeOffset: 2 },
      { value: "SSD", alpha2: "SS", displayName: "SOUTH SUDAN", timeOffset: 3 },
      { value: "ESP", alpha2: "ES", displayName: "SPAIN", timeOffset: 0 },
      { value: "LKA", alpha2: "LK", displayName: "SRI LANKA", timeOffset: 5 },
      { value: "KNA", alpha2: "KN", displayName: "ST. CHRISTOPHER AND NEVIS", timeOffset: -4 },
      { value: "LCA", alpha2: "LC", displayName: "ST. LUCIA", timeOffset: -4 },
      { value: "VCT", alpha2: "VC", displayName: "ST. VINCENT AND THE GRENADINES", timeOffset: -4 },
      { value: "SDN", alpha2: "SD", displayName: "SUDAN", timeOffset: 2 },
      { value: "SUR", alpha2: "SR", displayName: "SURINAME", timeOffset: -3 },
      { value: "SWZ", alpha2: "SZ", displayName: "ESWATINI", timeOffset: 2 },
      { value: "SWE", alpha2: "SE", displayName: "SWEDEN", timeOffset: 1 },
      { value: "CHE", alpha2: "CH", displayName: "SWITZERLAND", timeOffset: 1 },
      { value: "SYR", alpha2: "SY", displayName: "SYRIA", timeOffset: 2 },
      { value: "TJK", alpha2: "TJ", displayName: "TADZHIKISTAN", timeOffset: 5 },
      { value: "TWN", alpha2: "TW", displayName: "TAIWAN", timeOffset: 8 },
      { value: "TZA", alpha2: "TZ", displayName: "TANZANIA", timeOffset: 3 },
      { value: "THA", alpha2: "TH", displayName: "THAILAND", timeOffset: 7 },
      { value: "TLS", alpha2: "TL", displayName: "TIMOR-LESTE", timeOffset: 9 },
      { value: "TGO", alpha2: "TG", displayName: "TOGO", timeOffset: 0 },
      { value: "TON", alpha2: "TO", displayName: "TONGA", timeOffset: 13 },
      { value: "TTO", alpha2: "TT", displayName: "TRINIDAD AND TOBAGO", timeOffset: -4 },
      { value: "TUN", alpha2: "TN", displayName: "TUNISIA", timeOffset: 1 },
      { value: "TUR", alpha2: "TR", displayName: "TURKEY", timeOffset: 3 },
      { value: "TKM", alpha2: "TM", displayName: "TURKMENISTAN", timeOffset: 5 },
      { value: "TUV", alpha2: "TV", displayName: "TUVALU", timeOffset: 12 },
      { value: "USA", alpha2: "US", displayName: "U.S.A.", timeOffset: -5 },
      { value: "UGA", alpha2: "UG", displayName: "UGANDA", timeOffset: 3 },
      { value: "UKR", alpha2: "UA", displayName: "UKRAINE", timeOffset: 2 },
      { value: "ARE", alpha2: "AE", displayName: "UNITED ARAB EMIRATES", timeOffset: 4 },
      { value: "GBR", alpha2: "GB", displayName: "UNITED KINGDOM", timeOffset: 0 },
      { value: "URY", alpha2: "UY", displayName: "URUGUAY", timeOffset: -3 },
      { value: "UZB", alpha2: "UZ", displayName: "UZBEKISTAN", timeOffset: 5 },
      { value: "VUT", alpha2: "VU", displayName: "VANUATU", timeOffset: 11 },
      { value: "VAT", alpha2: "VA", displayName: "VATICAN", timeOffset: 1 },
      { value: "VEN", alpha2: "VE", displayName: "VENEZUELA", timeOffset: -4 },
      { value: "VNM", alpha2: "VN", displayName: "VIETNAM", timeOffset: 7 },
      { value: "YEM", alpha2: "YE", displayName: "YEMEN", timeOffset: 3 },
      { value: "ZMB", alpha2: "ZM", displayName: "ZAMBIA", timeOffset: 2 },
      { value: "ZWE", alpha2: "ZW", displayName: "ZIMBABWE", timeOffset: 2 },
    ];
  },
  getMarkerIconList() {
    return [
      [
        constants.ICON_IMAGE_PATH + "male_blue.png",
        constants.ICON_IMAGE_PATH + "male_green.png",
        constants.ICON_IMAGE_PATH + "male_red.png",
        constants.ICON_IMAGE_PATH + "male_yellow.png",
        constants.ICON_IMAGE_PATH + "female_blue.png",
        constants.ICON_IMAGE_PATH + "female_green.png",
        constants.ICON_IMAGE_PATH + "female_red.png",
        constants.ICON_IMAGE_PATH + "female_yellow.png",
      ],
      [
        constants.ICON_IMAGE_PATH + "car_blue.png",
        constants.ICON_IMAGE_PATH + "car_green.png",
        constants.ICON_IMAGE_PATH + "car_red.png",
        constants.ICON_IMAGE_PATH + "car_yellow.png",
        constants.ICON_IMAGE_PATH + "taxi_blue.png",
        constants.ICON_IMAGE_PATH + "taxi_green.png",
        constants.ICON_IMAGE_PATH + "taxi_red.png",
        constants.ICON_IMAGE_PATH + "taxi_yellow.png",
      ],
      [
        constants.ICON_IMAGE_PATH + "bus_blue.png",
        constants.ICON_IMAGE_PATH + "bus_green.png",
        constants.ICON_IMAGE_PATH + "bus_red.png",
        constants.ICON_IMAGE_PATH + "bus_yellow.png",
        constants.ICON_IMAGE_PATH + "truck_blue.png",
        constants.ICON_IMAGE_PATH + "truck_green.png",
        constants.ICON_IMAGE_PATH + "truck_red.png",
        constants.ICON_IMAGE_PATH + "truck_yellow.png",
      ],
      [
        constants.ICON_IMAGE_PATH + "train_blue.png",
        constants.ICON_IMAGE_PATH + "train_green.png",
        constants.ICON_IMAGE_PATH + "train_red.png",
        constants.ICON_IMAGE_PATH + "train_yellow.png",
        constants.ICON_IMAGE_PATH + "spex_blue.png",
        constants.ICON_IMAGE_PATH + "spex_green.png",
        constants.ICON_IMAGE_PATH + "spex_red.png",
        constants.ICON_IMAGE_PATH + "spex_yellow.png",
      ],
    ];
  },
  getSttExtensionPhraseCategoryList() {
    return [
      { key: 0, value_jp: "全般", value_en: "All" },
      { key: 1, value_jp: "固有名詞", value_en: "Proper Noun" },
      { key: 2, value_jp: "人名", value_en: "Person" },
      { key: 3, value_jp: "駅名", value_en: "Station" },
      { key: 4, value_jp: "地名", value_en: "Place" },
      { key: 5, value_jp: "会社", value_en: "Company" },
      { key: 6, value_jp: "部署", value_en: "Department" },
      { key: 7, value_jp: "役職", value_en: "Position" },
      { key: 8, value_jp: "記号", value_en: "Symbol" },
      { key: 9, value_jp: "元号", value_en: "Era" },
    ];
  },
  getResolutionList(i18n) {
    return [
      { value: 0, label: this.getMessageText(i18n, "item_cilent_resolution_option1") },
      { value: 1, label: this.getMessageText(i18n, "item_cilent_resolution_option2") },
      { value: 2, label: this.getMessageText(i18n, "item_cilent_resolution_option3") },
    ];
  },
  getDuplicateVolumeList(i18n) {
    return [
      {
        value: 10,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          10
        ),
      },
      {
        value: 20,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          20
        ),
      },
      {
        value: 30,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          30
        ),
      },
      {
        value: 40,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          40
        ),
      },
      {
        value: 50,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          50
        ),
      },
      {
        value: 60,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          60
        ),
      },
      {
        value: 70,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          70
        ),
      },
      {
        value: 80,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          80
        ),
      },
      {
        value: 90,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          90
        ),
      },
      {
        value: 100,
        label: this.getMessageText(i18n, "item_client_duplicate_volume_option").replace(
          "{value}",
          100
        ),
      },
    ];
  },
  getBellNotificationItems() {
    return [
      { name: "DISPLAY_NAME", description: "ベル表示名", description_en: "Bell Display Name" },
      { name: "TITLES", description: "タイトル", description_en: "Titles" },
      { name: "SELECTIONS", description: "選択肢", description_en: "Selections" },
      { name: "USED_LANGUAGE", description: "使用された言語", description_en: "Used Language" },
    ];
  },
  getBrowserLanguage(cookieLang) {
    if (cookieLang == null) {
      var lang = navigator.language ? navigator.language : navigator.userLanguage;
      if (lang.indexOf("ja") >= 0) {
        return "ja";
      } else {
        return "en";
      }
    } else {
      return cookieLang;
    }
  },
  compareStringWithNumber(s1, s2) {
    // #####################
    // inner functions BEGIN
    // #####################
    function isNumber(code) {
      if (code >= "0".codePointAt(0) && code <= "9".codePointAt(0)) {
        return 1;
      }

      if (code >= "０".codePointAt(0) && code <= "９".codePointAt(0)) {
        return 2;
      }

      return 0;
    }

    function getHalfWidthNumber(str, i) {
      var result = 0;
      let len = str.length;
      while (true) {
        if (i >= len) {
          break;
        }

        let code = str.codePointAt(i);
        if (code < "0".codePointAt(0) || code > "9".codePointAt(0)) {
          break;
        }
        result = result * 10 + code - "0".codePointAt(0);
        i++;
      }
      return { number: result, index: i };
    }

    function getFullWidthNumber(str, i) {
      var result = 0;
      let len = str.length;
      while (true) {
        if (i >= len) {
          break;
        }

        let code = str.codePointAt(i);
        if (code < "０".codePointAt(0) || code > "９".codePointAt(0)) {
          break;
        }
        result = result * 10 + code - "０".codePointAt(0);
        i++;
      }
      return { number: result, index: i };
    }
    // ###################
    // inner functions END
    // ###################

    var index1 = 0;
    var index2 = 0;
    var code1;
    var code2;
    var fNumber1;
    var fNumber2;

    var len1 = s1.length;
    var len2 = s2.length;
    while (index1 < len1 && index2 < len2) {
      code1 = s1.codePointAt(index1);
      code2 = s2.codePointAt(index2);
      fNumber1 = isNumber(code1);
      fNumber2 = isNumber(code2);

      if (fNumber1 != 0 && fNumber1 == fNumber2) {
        var number1;
        var number2;

        if (fNumber1 == 1) {
          number1 = getHalfWidthNumber(s1, index1);
        } else {
          number1 = getFullWidthNumber(s1, index1);
        }
        if (fNumber2 == 1) {
          number2 = getHalfWidthNumber(s2, index2);
        } else {
          number2 = getFullWidthNumber(s2, index2);
        }

        if (number1.number < number2.number) {
          return -1;
        } else if (number1.number > number2.number) {
          return 1;
        }

        let nLen1 = number1.index - index1;
        let nLen2 = number2.index - index2;
        if (nLen1 > nLen2) {
          return -1;
        } else if (nLen1 < nLen2) {
          return 1;
        }
        index1 = number1.index;
        index2 = number2.index;
      } else {
        if (code1 < code2) {
          return -1;
        } else if (code1 > code2) {
          return 1;
        }
        index1 += code1 < 0x10000 ? 1 : 2;
        index2 += code2 < 0x10000 ? 1 : 2;
      }
    }

    if (index1 >= len1 && index2 >= len2) {
      return 0;
    } else if (index1 >= len1) {
      return -1;
    } else {
      return 1;
    }
  },
  getFormattedLocalDatetime(datetime) {
    var year = datetime.getFullYear();
    var month = ("0" + (datetime.getMonth() + 1)).slice(-2);
    var day = ("0" + datetime.getDate()).slice(-2);
    var hours = ("0" + datetime.getHours()).slice(-2);
    var minutes = ("0" + datetime.getMinutes()).slice(-2);
    var seconds = ("0" + datetime.getSeconds()).slice(-2);
    return year + "/" + month + "/" + day + " " + hours + ":" + minutes + ":" + seconds;
  },
  changeAddressToNumeric(definedIp) {
    // convert definedIp to numeric for sorting key.
    let octetOfIp = definedIp.split(".");
    let numericIP = octetOfIp[0] * 16777216 + octetOfIp[1] * 65536 + octetOfIp[2] * 256;
    let lastOctet = octetOfIp[3].split("/");
    numericIP += Number(lastOctet[0]);
    if (lastOctet.length > 1) {
      numericIP += lastOctet[1] / 100;
    }
    return numericIP;
  },
  /**
   * IPアドレスを正規化する
   * @param ipAddress
   * @returns {null|string}
   */
  normalizeIpAddress(ipAddress) {
    try {
      // CIDR形式
      if (ipAddress.indexOf("/") >= 0) {
        const [addr, prefix] = ipaddr.parseCIDR(ipAddress);
        return addr.toNormalizedString() + "/" + prefix;
      }

      return ipaddr.parse(ipAddress).toNormalizedString();
    } catch (e) {
      return null;
    }
  },
  /**
   * IPアドレス(CIDR可、IPv4/IPv6混在可)をソート用に比較する
   * IPv4 < IPv6、アドレス昇順、プレフィックスなし < プレフィックス昇順、パース不能は末尾
   * @param ipA
   * @param ipB
   * @returns {number} -1 / 0 / 1
   */
  compareIpAddress(ipA, ipB) {
    const parse = (ip) => {
      try {
        if (ip.indexOf("/") >= 0) {
          const [addr, prefix] = ipaddr.parseCIDR(ip);
          return { addr, prefix };
        }
        return { addr: ipaddr.parse(ip), prefix: null };
      } catch (e) {
        return null;
      }
    };
    const ipAddrAndPrefixA = parse(ipA);
    const ipAddrAndPrefixB = parse(ipB);
    if (ipAddrAndPrefixA == null || ipAddrAndPrefixB == null) {
      // nullは末尾に
      return ipAddrAndPrefixA == null ? (ipAddrAndPrefixB == null ? 0 : 1) : -1;
    }
    if (ipAddrAndPrefixA.addr.kind() !== ipAddrAndPrefixB.addr.kind()) {
      // ipv4が先
      return ipAddrAndPrefixA.addr.kind() === "ipv4" ? -1 : 1;
    }
    const bytesA = ipAddrAndPrefixA.addr.toByteArray();
    const bytesB = ipAddrAndPrefixB.addr.toByteArray();
    for (let i = 0; i < bytesA.length; i++) {
      if (bytesA[i] !== bytesB[i]) {
        return bytesA[i] < bytesB[i] ? -1 : 1;
      }
    }
    if (ipAddrAndPrefixA.prefix === ipAddrAndPrefixB.prefix) {
      return 0;
    }
    if (ipAddrAndPrefixA.prefix == null || ipAddrAndPrefixB.prefix == null) {
      // prefixなしが先
      return ipAddrAndPrefixA.prefix == null ? -1 : 1;
    }
    return ipAddrAndPrefixA.prefix < ipAddrAndPrefixB.prefix ? -1 : 1;
  },
  /**
   * IPアドレスの形式が正しいかチェックする
   * @param ipAddress
   * @returns {boolean}
   */
  isValidIpAddress(ipAddress) {
    const ipAddressPart = ipAddress.split("/")[0];
    const isIpv6 = ipAddressPart.includes(":");
    const isStrictIpv4 = /^(\d{1,3}\.){3}\d{1,3}$/.test(ipAddressPart);

    // IPv6のゾーン識別子は許可しない
    if (isIpv6 && ipAddressPart.includes("%")) {
      return false;
    }
    // ipaddrのisValidでfalseにならないものを検証
    // ex: ipAddress = 111111 や 111.111
    if (!isIpv6 && !isStrictIpv4) {
      return false;
    }
    return ipAddress.indexOf("/") >= 0
      ? ipaddr.isValidCIDR(ipAddress)
      : ipaddr.isValid(ipAddress);
  },
  getGoogleMapApiKey() {
    return process.env.GOOGLE_MAP_KEY;
  },
  createCSVErrorData(csvErrorInfo) {
    const { errorUserInputs } = csvErrorInfo ?? {};
    if (!Array.isArray(errorUserInputs)) {
      return "";
    }
    return errorUserInputs.join("\n");
  },
  createCSVUnprocessedData(csvErrorInfo) {
    const { unprocessedUserInputs } = csvErrorInfo ?? {};
    if (!Array.isArray(unprocessedUserInputs)) {
      return "";
    }
    return unprocessedUserInputs.join("\n");
  },
  downloadCSVFile(fileName, csvData) {
    const blob = new Blob([`\uFEFF${csvData}`], { type: "application/csv;charset=UTF-8" });
    this.downloadFile(blob, fileName);
  },
  downloadFile(blob, fileName) {
    if (window.navigator.msSaveBlob) {
      // for IE11
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
    }
  },
  isSharedConsole() {
    // for development
    if (window.location.hostname === "localhost") {
      return true;
    }
    const sharedHostnames = ["console.buddycom.net", "stg-console.buddycom.net"];
    return (
      window.location.protocol === "https:" && sharedHostnames.includes(window.location.hostname)
    );
  },
  async sha256(str) {
    let buff = new Uint8Array([].map.call(str, (c) => c.charCodeAt(0))).buffer;
    let cryptoObj = window.crypto || window.msCrypto;
    let digest = await cryptoObj.subtle.digest("SHA-256", buff);
    return [].map.call(new Uint8Array(digest), (x) => ("00" + x.toString(16)).slice(-2)).join("");
  },
  getDeviceManagementApprovalStatusName(i18n, approvalStatus) {
    switch (approvalStatus) {
      case constants.DEVICE_MANAGEMENT_STATUS_UNAPPROVED:
        return this.getMessageText(i18n, "item_approval_status_unapproved");
      case constants.DEVICE_MANAGEMENT_STATUS_APPROVED:
        return this.getMessageText(i18n, "item_approval_status_approved");
      default:
        return "";
    }
  },
  messageMaker(messageArray) {
    return h(
      "div",
      messageArray.map((_message) => h("p", _message))
    );
  },
  showLoadingOverlay(selectors = ".app") {
    return ElLoading.service({
      lock: true,
      text: "Processing...",
      background: "rgba(0,0,0,0.7)",
      customClass: "loadingCustom",
      spinner: loadingIcon,
      target: document.querySelector(selectors),
    });
  },
  syncValidationState(syncedRef, formRef, watched) {
    watch(
      () => watched,
      () => {
        try {
          if (formRef.value) {
            formRef.value.validate((valid) => {
              syncedRef.value = valid;
            });
          }
        } catch (e) {
          console.error("Validation error:", e);
          syncedRef.value = false;
        }
      },
      { deep: true }
    );
  },
  camelToSpacedTitleCase(str) {
    const snake = humps.decamelize(str);
    const spaced = snake.replace(/_/g, " ");
    const newStr = spaced.replace(/\b\w/g, (s) => s.toUpperCase());
    return newStr;
  },
  bitShiftUserOption(userOption) {
    return 1 << userOption;
  },

  // emergency value -> label map
  EMERGENCY_VALUE_TO_LABEL: Object.freeze({
    0: "",
    1: "緊急",
    2: "定時確認",
    3: "非常：傾斜",
    4: "非常：静止",
    5: "非常：傾斜＆静止",
    6: "非常：動作",
  }),

  // helper to get emergency label from numeric value
  getEmergencyLabel(value) {
    const label = this.EMERGENCY_VALUE_TO_LABEL[value];
    return label !== undefined ? label : "";
  },

  getDirection16WithElapsed(lat1, lng1, lat2, lng2, elapsedMs) {
    if (elapsedMs == null || !isFinite(elapsedMs) || elapsedMs <= 0) {
      return null;
    }
    if (lat1 == null || lng1 == null || lat2 == null || lng2 == null) {
      return null;
    }

    const R = 6371000; // 地球の半径[m]
    const rad = Math.PI / 180;
    const φ1 = lat1 * rad;
    const φ2 = lat2 * rad;
    const Δφ = (lat2 - lat1) * rad;
    const Δλ = (lng2 - lng1) * rad;

    // 方位角（bearing）
    const y = Math.sin(Δλ) * Math.cos(φ2);
    const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
    let θ = Math.atan2(y, x);
    let deg = ((θ * 180) / Math.PI + 360) % 360;

    // 16方位インデックス (-11.25°〜+11.25°が北)
    const direction = Math.round(deg / 22.5) % 16;

    // 距離（ハバースイン公式）
    const a = Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    if (!isFinite(distance) || distance <= 0) {
      return null;
    }

    const seconds = elapsedMs / 1000;
    const speed = distance / seconds; // m/s

    return speed < 1 ? null : direction;
  },

  getOverlayUrlForDirection16(directionNumber) {
    const overlayUrl = "";
    switch (directionNumber) {
      case 0:
        return require("@/assets/icon_direction/icon_direction_N.png");
      case 1:
        return require("@/assets/icon_direction/icon_direction_NNE.png");
      case 2:
        return require("@/assets/icon_direction/icon_direction_NE.png");
      case 3:
        return require("@/assets/icon_direction/icon_direction_ENE.png");
      case 4:
        return require("@/assets/icon_direction/icon_direction_E.png");
      case 5:
        return require("@/assets/icon_direction/icon_direction_ESE.png");
      case 6:
        return require("@/assets/icon_direction/icon_direction_SE.png");
      case 7:
        return require("@/assets/icon_direction/icon_direction_SSE.png");
      case 8:
        return require("@/assets/icon_direction/icon_direction_S.png");
      case 9:
        return require("@/assets/icon_direction/icon_direction_SSW.png");
      case 10:
        return require("@/assets/icon_direction/icon_direction_SW.png");
      case 11:
        return require("@/assets/icon_direction/icon_direction_WSW.png");
      case 12:
        return require("@/assets/icon_direction/icon_direction_W.png");
      case 13:
        return require("@/assets/icon_direction/icon_direction_WNW.png");
      case 14:
        return require("@/assets/icon_direction/icon_direction_NW.png");
      case 15:
        return require("@/assets/icon_direction/icon_direction_NNW.png");
      default:
        return "";
    }
  },
  getIpRadioPrimaryLineList() {
    return [
      { key: 0, value: "Wi-Fi固定", bit: 1 },
      { key: 1, value: "Wi-Fi優先", bit: 1 },
      { key: 2, value: "SIM1固定", bit: 2 },
      { key: 3, value: "SIM1優先", bit: 2 },
      { key: 4, value: "SIM2固定", bit: 4 },
      { key: 5, value: "SIM2優先", bit: 4 },
    ];
  },
  getIpRadioPrimaryLineFilteredList(enableLineFlag) {
    const filteredList = this.getIpRadioPrimaryLineList().filter(
      (option) => (option.bit & enableLineFlag) === option.bit
    );

    // enableLineFlagが1(WiFi利用のみ)の場合は"Wi-Fi優先"は不要のため"Wi-Fi固定"のみを返却
    if (enableLineFlag === 1) {
      return filteredList.filter((option) => option.key === 0);
    }

    return filteredList;
  },
  getIpRadioPrimaryLine(key) {
    const item = this.getIpRadioPrimaryLineList().find((option) => option.key === key);
    return item?.value ?? "";
  },
  formatIpRadioVersionForDisplay(version) {
    if (typeof version !== "string") {
      return version;
    }

    const parts = version.split(".");
    if (parts.length !== 4) {
      return version;
    }

    if (parts[3] !== "00") {
      return version;
    }

    return parts.slice(0, 3).join(".");
  },
  getIpRadioIdList(list = []) {
    let idList = [];
    if (!Array.isArray(list)) return [];
    for (let target of list) {
      if (target.type != null) {
        if (target.type == constants.OBJECT_IP_RADIO) {
          idList.push(target.id);
        }
      } else {
        if (!target.restrictions || !target.restrictions.includes(constants.RESTRICTION_LOGIN)) {
          idList.push(target.userId);
        }
      }
    }
    return idList;
  },
  getUserKindList(currentLocale) {
    if (currentLocale === "ja") {
      return [
        { value: "normal", description: "ユーザー" },
        { value: "admin_only", description: "無線機管理ユーザー" },
      ];
    } else {
      return [
        { value: "normal", description: "Normal User" },
        { value: "admin_only", description: "Admin-Only User" },
      ];
    }
  },
  getUserIdList(list = []) {
    let idList = [];
    if (!Array.isArray(list)) return [];
    for (let target of list) {
      if (target.type != null) {
        if (target.type == constants.OBJECT_USER) {
          if (!target.restrictions || !target.restrictions.includes(constants.RESTRICTION_LOGIN)) {
            idList.push(target.id);
          }
        }
      } else {
        if (!target.restrictions || !target.restrictions.includes(constants.RESTRICTION_LOGIN)) {
          idList.push(target.userId);
        }
      }
    }
    return idList;
  },
  getTalkgroupIdList(list = []) {
    let idList = [];
    if (!Array.isArray(list)) return [];
    for (let target of list) {
      if (target.talkgroupId != null) {
        idList.push(target.talkgroupId);
      } else if (target.id != null) {
        idList.push(target.id);
      }
    }
    return idList;
  },
  getTableColumns() {
    return {
      buddycomAccount: [
        { visible: true, prop: "name", label: "ユーザーID", width: "150" },
        { visible: true, prop: "loginId", label: "ログインID", width: "200" },
        { visible: true, prop: "displayName", label: "ユーザー表示名", width: "150" },
        { visible: true, prop: "talkgroupCounts", label: "参加グループ数", width: "150" },
        { visible: false, prop: "organization", label: "組織名", width: "100" },
        { visible: false, prop: "title", label: "役職名", width: "150" },
        { visible: false, prop: "phoneNumber", label: "電話番号", width: "150" },
        { visible: false, prop: "emailAddress", label: "メールアドレス", width: "150" },
        { visible: true, prop: "easyLogin", label: "かんたんログイン", width: "150" },
        {
          visible: false,
          prop: "showGroupUrl",
          label: "かんたんログインQRコードの表示",
          width: "240",
        },
        { visible: true, prop: "interrupt", label: "割り込み権限", width: "150" },
        { visible: true, prop: "mapTalk", label: "マップ通話", width: "150" },
        { visible: true, prop: "speechToText", label: "音声テキスト化", width: "150" },
        { visible: true, prop: "translation", label: "翻訳", width: "150" },
        { visible: true, prop: "tracking", label: "動態管理", width: "150" },
        { visible: true, prop: "video", label: "ライブキャスト", width: "150" },
        { visible: true, prop: "existsToken", label: "使用状況", width: "150" },
        { visible: true, prop: "tokenCreateDate", label: "使用開始時刻", width: "150" },
      ],
      group: [
        { visible: true, prop: "name", label: "グループID", width: "150" },
        { visible: true, prop: "displayName", label: "グループ表示名", width: "150" },
        { visible: true, prop: "userCount", label: "参加ユーザー数", width: "150" },
        { visible: true, prop: "saveVoice", label: "音声データの保存", width: "150" },
        { visible: false, prop: "storageName", label: "データの保存先", width: "180" },
        { visible: true, prop: "durationLimit", label: "通話自動終了 (秒)	", width: "150" },
        { visible: true, prop: "talkType", label: "通話形式", width: "150" },
        { visible: false, prop: "lowBitRate", label: "低ビットレートモード", width: "180" },
        { visible: true, prop: "location", label: "位置情報", width: "150" },
        { visible: true, prop: "mapTalk", label: "マップ通話", width: "150" },
        { visible: true, prop: "speechToText", label: "音声テキスト化", width: "150" },
        { visible: true, prop: "translation", label: "翻訳", width: "150" },
        { visible: false, prop: "video", label: "ライブキャスト", width: "150" },
      ],
      ipRadio: [
        { visible: true, prop: "name", label: "ユーザーID", width: "150" },
        { visible: true, prop: "displayName", label: "ユーザー表示名", width: "150" },
        { visible: true, prop: "talkgroupCounts", label: "参加グループ数", width: "150" },
        { visible: false, prop: "organization", label: "組織名", width: "100" },
        { visible: false, prop: "title", label: "役職名", width: "150" },
        { visible: true, prop: "interrupt", label: "割り込み権限", width: "150" },
        { visible: true, prop: "speechToText", label: "音声テキスト化", width: "150" },
        { visible: true, prop: "translation", label: "翻訳", width: "150" },
        { visible: true, prop: "tracking", label: "動態管理", width: "150" },
        { visible: true, prop: "modelName", label: "機種名", width: "150" },
        { visible: false, prop: "destinationCode", label: "仕向", width: "150" },
        { visible: true, prop: "serialNumber", label: "シリアル番号", width: "150" },
        { visible: false, prop: "contractNumber", label: "契約番号", width: "150" },
        { visible: true, prop: "planName", label: "プラン名", width: "150" },
        { visible: true, prop: "optionName", label: "オプション名", width: "150" },
        ...(FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE
          ? [{ visible: true, prop: "currentLine", label: "使用中の回線設定", width: "150" }]
          : [{ visible: true, prop: "primaryLine", label: "回線設定", width: "150" }]),
        { visible: false, prop: "version", label: "バージョン", width: "200" },
        { visible: true, prop: "settingName", label: "無線機設定", width: "150" },
        { visible: false, prop: "customField1", label: "カスタム項目", width: "150" },
        { visible: true, prop: "managementNumber", label: "管理番号", width: "150" },
        ...(FEATURE_JKC_STUN
          ? [{ visible: false, prop: "isStun", label: "送受信禁止", width: "150" }]
          : []),
        { visible: true, prop: "existsToken", label: "使用状況", width: "150" },
        { visible: true, prop: "tokenCreateDate", label: "使用開始時刻", width: "150" },
      ],
    };
  },
  getSearchCondition(selectedTableOption) {
    switch (selectedTableOption) {
      case constants.TABLE_OPTIONS.buddycomAccount:
        return [
          { value: "userId", labelKey: "message.item_userId" },
          { value: "userName", labelKey: "message.item_userDisplayName" },
          { value: "organization", labelKey: "message.item_organization" },
          { value: "title", labelKey: "message.item_job_title" },
          { value: "phone", labelKey: "message.item_tenant_phone" },
        ];
      case constants.TABLE_OPTIONS.group:
        return [
          { value: "groupId", labelKey: "message.item_groupId" },
          { value: "groupName", labelKey: "message.item_groupDisplayName" },
        ];
      case constants.TABLE_OPTIONS.ipRadioAccount:
        return [
          { value: "userId", labelKey: "message.item_userId" },
          { value: "userName", labelKey: "message.item_userDisplayName" },
          { value: "organization", labelKey: "message.item_organization" },
          { value: "title", labelKey: "message.item_job_title" },
          { value: "modelName", labelKey: "機種名" },
          { value: "destinationCode", labelKey: "仕向" },
          { value: "serialNumber", labelKey: "シリアル番号" },
          { value: "contractNumber", labelKey: "契約番号" },
          { value: "planName", labelKey: "プラン名" },
          { value: "optionName", labelKey: "オプション名" },
          ...(FEATURE_JKC_SEPARATE_CURRENT_LINE_FROM_PRIMARY_LINE
            ? [{ value: "currentLine", labelKey: "使用中の回線設定" }]
            : [{ value: "primaryLine", labelKey: "回線設定" }]),
          { value: "version", labelKey: "バージョン" },
          { value: "settingName", labelKey: "無線機設定" },
          { value: "customField1", labelKey: "カスタム項目" },
          { value: "managementNumber", labelKey: "管理番号" },
        ];
    }
  },
  getConsoleOperationPermissions(i18n) {
    return [
      {
        type: constants.GRANT_LEVEL_PERMISSION.NONE,
        displayName: this.getMessageText(i18n, "item_do_not_grant"),
      },
      {
        type: constants.GRANT_LEVEL_PERMISSION.VIEW,
        displayName: this.getMessageText(i18n, "item_grant_view_permissions_for_all_levels"),
      },
      {
        type: constants.GRANT_LEVEL_PERMISSION.EDIT,
        displayName: this.getMessageText(i18n, "item_grant_edit_permissions_for_all_levels"),
      },
    ];
  },
  isDealerAccount(appData) {
    return !!(appData && appData.isRadioTransitionUser);
  },
  isGeneralAdminAccount(appData) {
    return !!(appData && !appData.isRadioTransitionUser && appData.isRadioAdminOnlyUser);
  },
  isConsolePermissionControlledAccount(appData) {
    // コンソール操作権限が適用されるのは、無線機管理ユーザーと無線機管理一般ユーザー
    return this.isDealerAccount(appData) || this.isGeneralAdminAccount(appData);
  },
  hasRadioIntegratePermission(appData, permissionName) {
    if (!appData) {
      return false;
    }

    if (!appData.radioIntegratePermission) {
      return false;
    }

    return !!appData.radioIntegratePermission[permissionName];
  },
  canManageConsoleUserGroupDefinition(appData) {
    if (!this.isConsolePermissionControlledAccount(appData)) {
      return true;
    }
    return this.hasRadioIntegratePermission(
      appData,
      "consoleManagementEditUserAndTalkGroupDefinition"
    );
  },
  canManageConsoleUserTalkgroupAssignment(appData) {
    if (!this.isConsolePermissionControlledAccount(appData)) {
      return true;
    }
    return this.hasRadioIntegratePermission(
      appData,
      "consoleManagementEditUserTalkGroupAssignment"
    );
  },
  canViewConsoleTracking(appData) {
    if (!this.isConsolePermissionControlledAccount(appData)) {
      return true;
    }
    return this.hasRadioIntegratePermission(appData, "consoleManagementTracking");
  },
  isTrackingOnlyGeneralAdmin(appData) {
    return this.isGeneralAdminAccount(appData) && this.canViewConsoleTracking(appData);
  },
  canManageRadioSettingDefinition(appData) {
    return (
      appData.radioManageUser ||
      this.hasRadioIntegratePermission(appData, "radioManagementEditRadioSettingDefinition")
    );
  },
  canManageRadioSettingAssignment(appData) {
    return (
      appData.radioManageUser ||
      this.hasRadioIntegratePermission(appData, "radioManagementEditRadioSettingAssignment")
    );
  },
  canEditRadioSettingWifiItems(appData) {
    return (
      this.canManageRadioSettingDefinition(appData) ||
      this.hasRadioIntegratePermission(
        appData,
        "radioManagementEditRadioSettingWifiItemsDefinition"
      )
    );
  },
  canEditIpRadioDisplayItems(appData) {
    return (
      appData.radioManageUser ||
      this.hasRadioIntegratePermission(
        appData,
        "radioManagementEditRadioUserDisplayItemsDefinition"
      )
    );
  },
  isRadioAvailablePlan(appData) {
    if (
      appData == null ||
      !appData.basicContract == null ||
      appData.basicContract.planType == null
    ) {
      return false;
    }

    return (
      appData.basicContract.planType === constants.LICENSE_PLAN_TALK_ENT ||
      appData.basicContract.planType === constants.LICENSE_PLAN_LIVE_ENT ||
      appData.basicContract.planType === constants.LICENSE_PLAN_SEPARATE
    );
  },
  isEnterprisePlan(appData) {
    if (
      appData == null ||
      appData.basicContract == null ||
      appData.basicContract.planType == null
    ) {
      return false;
    }

    return (
      appData.basicContract.planType === constants.LICENSE_PLAN_TALK_ENT ||
      appData.basicContract.planType === constants.LICENSE_PLAN_LIVE_ENT
    );
  },
};
